<template>
  <div class="head-nav">
    <el-row>
      <el-col :span="2" class="logo-container">
        <el-link href="/" :underline="false" class="title" style="color: #fff;">管理后台</el-link>
      </el-col>
      <el-col :span="5" class="user">
        <div class="userinfo" style="width: 300px;float: right;">
          <span>
            <el-select v-model="company_name" filterable remote reserve-keyword placeholder="请输入公司字号筛选公司" size="mini"
              clearable :remote-method="searchRemoteCompanyMethodHead" :loading="loading" @change="chooseCompany">
              <el-option v-for="company in searchCompaniesHead" :key="company.id" :label="company.company_name"
                :value="company.id">
              </el-option>
            </el-select>
          </span>
          <span style="width: 25px; line-height: 20px; cursor: pointer" @click="handleShowChat">
            <el-badge v-show="imUnreadCount > 0" :value="imUnreadCount" class="item">
              <i style="font-size: 25px" class="el-icon-chat-dot-round"></i>
            </el-badge>
            <i style="font-size: 25px" v-show="imUnreadCount === 0" class="el-icon-chat-dot-round"></i>
          </span>
          <span>
            <el-popover placement="bottom" width="300" trigger="hover">
              <div style="text-align: center;margin-bottom: 0.3rem">
                <el-row style="margin-top: 0.2rem" :gutter="20">
                  <el-col :span="8" v-if="headNodeData.indexOf('添加公司') !== -1">
                    <div style="
                        padding: 0.08rem;
                        text-align: center;
                        border-radius: 8px;
                        cursor: pointer;
                      " @click="handleComOpen" @mouseover="mouseOver('com')" @mouseleave="mouseLeave"
                      :class="{ mon: mover === 'com' }">
                      <p style="font-size: 0.6rem; color: #409EFF">
                        <i class="el-icon-office-building"></i>
                      </p>
                      <p class="pmt">添加公司</p>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <el-divider class="divider_style"></el-divider>
                  </el-col>
                </el-row>
                <el-row style="margin-top: 0.2rem" :gutter="20">
                  <el-col :span="8">
                    <div style="
                        padding: 0.08rem;
                        text-align: center;
                        border-radius: 8px;
                        cursor: pointer;
                      " @click="handleClueOpen" @mouseover="mouseOver('clue')" @mouseleave="mouseLeave"
                      :class="{ mon: mover === 'clue' }">
                      <p style="font-size: 0.6rem; color: #409EFF">
                        <i class="el-icon-s-finance"></i>
                      </p>
                      <p class="pmt">创建线索</p>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div style="
                        padding: 0.08rem;
                        text-align: center;
                        border-radius: 8px;
                        cursor: pointer;
                      " @click="handleBOOpen" @mouseover="mouseOver('bo')" @mouseleave="mouseLeave"
                      :class="{ mon: mover === 'bo' }">
                      <p style="font-size: 0.6rem; color: #67c23a">
                        <i class="el-icon-s-cooperation"></i>
                      </p>
                      <p class="pmt">创建商机</p>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <el-divider class="divider_style"></el-divider>
                  </el-col>
                </el-row>
                <el-row style="margin-top: 0.2rem" :gutter="20">
                  <el-col :span="8">
                    <div style="
                        padding: 0.08rem;
                        text-align: center;
                        border-radius: 8px;
                        cursor: pointer;
                      " @click="handleExpOpen" @mouseover="mouseOver('exp')" @mouseleave="mouseLeave"
                      :class="{ mon: mover === 'exp' }">
                      <p style="font-size: 0.6rem; color: #409eff">
                        <i class="el-icon-truck"></i>
                      </p>
                      <p class="pmt">创建快递</p>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div style="
                        padding: 0.08rem;
                        text-align: center;
                        border-radius: 8px;
                        cursor: pointer;
                      " @click="handleMatterOpen" @mouseover="mouseOver('matter')" @mouseleave="mouseLeave"
                      :class="{ mon: mover === 'matter' }">
                      <p style="font-size: 0.6rem; color: #67c23a">
                        <i class="el-icon-s-flag"></i>
                      </p>
                      <p class="pmt">创建待办事项</p>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div style="
                        padding: 0.08rem;
                        text-align: center;
                        border-radius: 8px;
                        cursor: pointer;
                      " @click="handBinding" @mouseover="mouseOver('binding')" @mouseleave="mouseLeave"
                      :class="{ mon: mover === 'binding' }">
                      <p style="font-size: 0.6rem; color: #E6A23C">
                        <i class="el-icon-connection"></i>
                      </p>
                      <p class="pmt">绑定小程序</p>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <el-divider class="divider_style"></el-divider>
                  </el-col>
                </el-row>
                <el-row style="margin-top: 0.2rem" :gutter="20">
                  <el-col :span="8">
                    <div style="
                        padding: 0.08rem;
                        text-align: center;
                        border-radius: 8px;
                        cursor: pointer;
                      " @click="handleAdviceOpen" @mouseover="mouseOver('advice')" @mouseleave="mouseLeave"
                      :class="{ mon: mover === 'advice' }">
                      <p style="font-size: 0.6rem; color: #409eff">
                        <i class="el-icon-reading"></i>
                      </p>
                      <p class="pmt">创建续费建议</p>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div style="
                        padding: 0.08rem;
                        text-align: center;
                        border-radius: 8px;
                        cursor: pointer;
                      " @click="handleQualityOpen" @mouseover="mouseOver('quality')" @mouseleave="mouseLeave"
                      :class="{ mon: mover === 'quality' }">
                      <p style="font-size: 0.6rem; color: #67c23a">
                        <i class="el-icon-folder-checked"></i>
                      </p>
                      <p class="pmt">创建服务质检</p>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <el-divider class="divider_style"></el-divider>
                  </el-col>
                </el-row>
                <el-row style="margin-top: 0.2rem" :gutter="20">
                  <el-col :span="8">
                    <div style="
                        padding: 0.08rem;
                        text-align: center;
                        border-radius: 8px;
                        cursor: pointer;
                      " @click="openSendMsgDialog" @mouseover="mouseOver('msg')" @mouseleave="mouseLeave"
                      :class="{ mon: mover === 'msg' }">
                      <p style="font-size: 0.6rem; color: #409eff">
                        <i class="el-icon-message"></i>
                      </p>
                      <p class="pmt">发送短信</p>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div style="
                        padding: 0.08rem;
                        text-align: center;
                        border-radius: 8px;
                        cursor: pointer;
                      " @click="openDialpadDialog" @mouseover="mouseOver('dialpad')" @mouseleave="mouseLeave"
                      :class="{ mon: mover === 'dialpad' }">
                      <p style="font-size: 0.6rem; color: #67C23A">
                        <i class="el-icon-phone-outline"></i>
                      </p>
                      <p class="pmt">电话外呼</p>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <el-divider class="divider_style"></el-divider>
                  </el-col>
                </el-row>
                <el-row style="margin-top: 0.2rem" :gutter="20">
                  <el-col :span="8">
                    <div style="
                        padding: 0.08rem;
                        text-align: center;
                        border-radius: 8px;
                        cursor: pointer;
                      " @click="openEncryptPhoneDialog" @mouseover="mouseOver('encryptPhone')" @mouseleave="mouseLeave"
                      :class="{ mon: mover === 'encryptPhone' }">
                      <p style="font-size: 0.6rem; color: #409eff">
                        <i class="el-icon-postcard"></i>
                      </p>
                      <p class="pmt">加密手机号</p>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div style="
                        padding: 0.08rem;
                        text-align: center;
                        border-radius: 8px;
                        cursor: pointer;
                      " @click="openDecryptPhoneDialog" @mouseover="mouseOver('decryptPhone')" @mouseleave="mouseLeave"
                      :class="{ mon: mover === 'decryptPhone' }">
                      <p style="font-size: 0.6rem; color: #67C23A">
                        <i class="el-icon-view"></i>
                      </p>
                      <p class="pmt">解密手机号</p>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <el-divider class="divider_style"></el-divider>
                  </el-col>
                </el-row>
                <el-row style="margin-top: 0.2rem" :gutter="20">
                  <el-col :span="8">
                    <div style="
                        padding: 0.08rem;
                        text-align: center;
                        border-radius: 8px;
                        cursor: pointer;
                      " @click="openExportPhoneDialog" @mouseover="mouseOver('exportPhone')" @mouseleave="mouseLeave"
                      :class="{ mon: mover === 'exportPhone' }">
                      <p style="font-size: 0.6rem; color: #409eff">
                        <i class="el-icon-folder-opened"></i>
                      </p>
                      <p class="pmt">手机号导出</p>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <el-divider class="divider_style"></el-divider>
                  </el-col>
                </el-row>
              </div>
              <i class="el-icon-menu" slot="reference"
                style="color: snow; font-size: 0.6rem; vertical-align: middle"></i>
            </el-popover>
          </span>

          <span class="username">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                <el-avatar style="margin-bottom: .1rem;" :size="40"> {{ userName }} </el-avatar>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="info">个人信息</el-dropdown-item>
                <!-- <el-dropdown-item command="flag" >
                  <span @click="flagPannel(user.id)">
                    个人目标
                  </span>
                </el-dropdown-item> -->
                <el-dropdown-item command="whether">
                  <span @click="whetherOnlineFun(whetherOnline, user.id)">
                    <span style="color:green" v-if="whetherOnline == 1">在线</span>
                    <span style="color:red" v-else>离线</span>
                  </span>
                </el-dropdown-item>
                <el-dropdown-item command="logout">退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="添加公司" :visible.sync="addComdVisible" width="30%" :before-close="handleAddComClose"
      :append-to-body="true">
      <div>
        <el-form ref="addComform" :model="addComForm" :rules="addComRules" label-width="80px" size="mini">
          <el-form-item label="公司名称" prop="company_name">
            <el-input v-model="addComForm.company_name"></el-input>
          </el-form-item>
          <el-form-item label="业务员" prop="saler_id">
            <el-select v-model="addComForm.saler_id" placeholder="请选择业务员" clearable filterable multiple>
              <el-option v-for="saler in salerData" :key="saler.id" :label="saler.username"
                :value="saler.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="text-r">
            <el-button type="primary" @click="onAddSubmit('addComform')">创 建</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="发送短信" :visible.sync="sendMsgDialog" width="30%" :before-close="handleSendMsgDialogClose"
      :append-to-body="true">
      <div>
        <el-form ref="sendMsgForm" :model="sendMsgForm" :rules="sendMsgFormRules" label-width="80px" size="mini">
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="sendMsgForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="短信内容" prop="msg">
            <el-input v-model="sendMsgForm.msg" type="textarea" style="white-space: pre"></el-input>
          </el-form-item>
          <el-form-item class="text-r">
            <el-button type="primary" @click="sendMsgFormSubmit('sendMsgForm')">发 送</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="加密手机号" :visible.sync="encryptPhoneDialog" width="40%"
      :before-close="handleEncryptPhoneDialogClose" :append-to-body="true">
      <div>
        <el-form ref="encryptPhoneForm" :model="encryptPhoneForm" :rules="encryptPhoneFormRules" label-width="100px"
          size="mini">
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="encryptPhoneForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="密文手机号" prop="encryptedPhone" v-if="encryptPhoneForm.encryptedPhone">
            <el-input v-model="encryptPhoneForm.encryptedPhone" type="textarea" style="white-space: pre"></el-input>
          </el-form-item>
          <el-form-item class="text-r">
            <el-button type="primary" @click="sendEncryptPhoneFormSubmit('encryptPhoneForm')">加 密</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog title="导出手机号" :visible.sync="exportPhoneDialog" width="40%" :before-close="handleExportPhoneDialogClose"
      :append-to-body="true">
      <export_phone v-if="exportPhoneDialog" @exportTaskAnswer="exportTaskAnswer" />
    </el-dialog>

    <el-dialog title="解密手机号" :visible.sync="decryptPhoneDialog" width="40%"
      :before-close="handleDecryptPhoneDialogClose" :append-to-body="true">
      <div>
        <el-form ref="decryptPhoneForm" :model="decryptPhoneForm" :rules="decryptPhoneFormRules" label-width="95px"
          size="mini">
          <el-form-item label="手机号" prop="phone" v-if="decryptPhoneForm.phone">
            <el-input v-model="decryptPhoneForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="密文手机号" prop="encryptedPhone">
            <el-input v-model="decryptPhoneForm.encryptedPhone" type="textarea" style="white-space: pre"></el-input>
          </el-form-item>
          <el-form-item class="text-r">
            <el-button type="primary" @click="sendDecryptPhoneFormSubmit('decryptPhoneForm')">解 密</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog title="绑定小程序" :visible.sync="Binding" :before-close="handleBindingClose" :append-to-body="true"
      width="35%">
      <el-divider></el-divider>
      <el-row>
        <el-col :span="5" class="m-label">小程序用户编号：</el-col>
        <el-col :span="17" class="m-label">
          <el-input v-model="psId" placeholder="请输入小程序小程序用户编号"></el-input>
        </el-col>
      </el-row>
      <el-row class="mt-10 tr">
        <el-button type="primary" :size="inputSize" @click.native="handBindingSave">绑定</el-button>
      </el-row>
    </el-dialog>
    <el-dialog title="创建商机" :visible.sync="BODialog" :before-close="handleBODialogClose" :append-to-body="true"
      width="35%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <div class="tabs_line">
          <div class="lines"></div>
          <h3 class="tabs-title">基础信息</h3>
        </div>
        <el-divider></el-divider>
        <el-row class="rmt">
          <el-col :span="4" class="m-label">公司名称：</el-col>
          <el-col :span="18" class="m-label">
            <el-select v-model="addData.company_id" filterable remote reserve-keyword placeholder="请输入公司字号筛选公司"
              :size="inputSize" clearable :remote-method="remoteMethod" :loading="loading">
              <el-option v-for="company in companies" :key="company.id" :label="company.company_name"
                :value="company.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="rmt">
          <el-col :span="4" class="m-label">商机内容：</el-col>
          <el-col :span="18" class="m-label">
            <el-select multiple :filterable="true" v-model="addData.bussin_content" placeholder="请选择商机内容 可多选"
              :size="inputSize" clearable>
              <el-option v-for="(item, index) in bussiness_content" :key="index" :label="item.bussin_name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="rmt">
          <el-col :span="4" class="m-label" style="display: flex">商机分配：</el-col>
          <el-col :span="18" class="m-label">
            <el-select :filterable="true" v-model="addData.uid" placeholder="此项不选默认不分配   可选择将商机分配给指定人员"
              :size="inputSize" clearable>
              <el-option v-for="(item, index) in users" :key="index" :label="item.username" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="rmt">
          <el-col :span="4" class="m-label">
            <el-tooltip content="紧急程度：" placement="top">
              <span class="count_style" style="display: inherit">紧急程度：</span>
            </el-tooltip>
          </el-col>
          <el-col :span="18" class="m-label">
            <el-radio-group v-model="addData.urgency" :size="inputSize">
              <el-radio-button :label="1">普通</el-radio-button>
              <el-radio-button :label="2">紧急</el-radio-button>
              <el-radio-button :label="3">重要</el-radio-button>
              <el-radio-button :label="4">特殊</el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row class="rmt">
          <el-col :span="4" class="m-label">其他备注：</el-col>
          <el-col :span="18">
            <el-input type="textarea" :autosize="textareaSize2" v-model="addData.remark" clearable></el-input>
          </el-col>
        </el-row>
        <el-row class="mt-10 tr">
          <el-button type="primary" :size="inputSize" @click="handleAddSave">添加</el-button>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog title="修改地址" :visible.sync="editAddressDialog" :modal="false" width="30%" :append-to-body="true">
      <el-form :model="editAddressForm" :rules="addressRules" ref="editAddressForm" label-width="100px">
        <el-form-item label="收件人" prop="addressee">
          <el-input v-model="editAddressForm.addressee" size="mini" placeholder="请填写收件人"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="address_phone">
          <el-input v-model="editAddressForm.address_phone" size="mini" placeholder="请填写手机号"></el-input>
        </el-form-item>
        <el-form-item label="收件人区域" prop="receiver_place">
          <el-select v-model="editAddressForm.receiver_place_pro" placeholder="省" clearable filterable size="mini"
            style="width: 100%" @click.native="getAddressPro" @change="getAddressCity">
            <el-option v-for="item in addressProOptions" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="editAddressForm.receiver_place_city" placeholder="市" clearable filterable size="mini"
            style="width: 100%" @change="getAddressTown">
            <el-option v-for="item in addressCityOptions" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="editAddressForm.receiver_place_town" placeholder="区/县" clearable filterable size="mini"
            style="width: 100%">
            <el-option v-for="item in addressTownOptions" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收件地址" prop="address">
          <el-input v-model="editAddressForm.address" size="mini" placeholder="请填写收件地址"></el-input>
        </el-form-item>
      </el-form>
      <div style="margin-top: 0.15rem; text-align: right">
        <el-button type="primary" size="mini" @click="doEdit('editAddressForm')">保存</el-button>
      </div>
    </el-dialog>
    <el-drawer title="录入快递信息" :visible.sync="expManageIndrawer" :direction="direction" :before-close="handleClose"
      size="40%" :append-to-body="true">
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form :model="expruleForm" :rules="rules" ref="expruleForm" label-width="110px" class="">
          <el-form-item label="类型" prop="sor">
            <el-radio-group v-model="expruleForm.sor" size="mini">
              <el-radio-button label="s">发件</el-radio-button>
              <el-radio-button label="r">收件</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="收件人(内部)" prop="receiver" v-if="expruleForm.sor === 'r'">
            <el-select v-model="expruleForm.receiver" filterable placeholder="请选择收件人" @focus="getReceiver" size="mini"
              style="width: 100%" clearable @change="getUserPhone">
              <el-option v-for="item in receiverOptions" :key="item.id" :label="item.username" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公司名称" prop="company_id">
            <el-select v-model="expruleForm.company_id" filterable remote reserve-keyword placeholder="请输入公司名称筛选公司"
              size="mini" clearable :remote-method="searchRemoteCompanyMethodTypein" :loading="searchLoadingTypein"
              style="width: 100%" @change="getUserAddress">
              <el-option v-for="searchCompany in searchCompaniesTypein" :key="searchCompany.id"
                :label="searchCompany.company_name" :value="searchCompany.id + '|' + searchCompany.company_name">
              </el-option>
            </el-select>
            <div v-if="userAdressOptions && expruleForm.sor === 's'" :gutter="0"
              style="max-height: 300px; overflow: auto">
              <el-row :gutter="0" v-for="(item, index) in userAdressOptions" :key="item.id" style="
                  border: 1px solid #dcdfe6;
                  border-radius: 10px;
                  padding-left: 0.2rem;
                  margin-bottom: 0.2rem;
                  cursor: pointer;
                " :class="{ active: cIndex == index }" @click.native="chooseThis(item, index)">
                <el-col :span="6" :title="item.addressee" style="
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                  ">
                  <span>收件人：</span>
                  <span style="color: #409eff">{{ item.addressee }}</span>
                </el-col>
                <el-col :span="10" style="
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                  " :title="item.address_phone">
                  <span>收件人电话：</span>
                  <span style="color: #67c23a">{{ item.address_phone }}</span>
                </el-col>
                <el-col :span="3" :offset="5" style="
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    text-align: center;
                  ">
                  <el-tooltip class="item" effect="dark" content="修改地址" placement="top" v-if="sIndex == index">
                    <i class="el-icon-edit" style="color: #409eff; font-size: 0.38rem"
                      @click="openEditAddressDialog(item)"></i>
                  </el-tooltip>
                </el-col>
                <el-col :span="24" style="
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                  " :title="item.pro.name + ' ' + item.city.name + ' ' + item.town.name"
                  v-if="item.pro && item.city && item.town">
                  <span>区域：</span>
                  <span style="color: #e6a23c">{{
                    item.pro.name + " " + item.city.name + " " + item.town.name
                  }}</span>
                </el-col>
                <el-col :span="24" style="
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                  " :title="item.address">
                  <span>地址：</span>
                  <span style="color: #e6a23c">{{ item.address }}</span>
                </el-col>
              </el-row>
              <el-row style="text-align: right">
                <el-popover placement="left-start" width="500" trigger="click">
                  <el-form :model="addAddressForm" :rules="addressRules" ref="addAddressForm" label-width="100px">
                    <el-form-item label="收件人" prop="addressee">
                      <el-input v-model="addAddressForm.addressee" size="mini" placeholder="请填写收件人"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="address_phone">
                      <el-input v-model="addAddressForm.address_phone" size="mini" placeholder="请填写手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="收件人区域" prop="receiver_place">
                      <el-select v-model="addAddressForm.receiver_place_pro" placeholder="省" clearable filterable
                        size="mini" style="width: 100%" @click.native="getAddressPro" @change="getAddressCity">
                        <el-option v-for="item in addressProOptions" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                      <el-select v-model="addAddressForm.receiver_place_city" placeholder="市" clearable filterable
                        size="mini" style="width: 100%" @change="getAddressTown">
                        <el-option v-for="item in addressCityOptions" :key="item.id" :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                      <el-select v-model="addAddressForm.receiver_place_town" placeholder="区/县" clearable filterable
                        size="mini" style="width: 100%">
                        <el-option v-for="item in addressTownOptions" :key="item.id" :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="收件地址" prop="address">
                      <el-input v-model="addAddressForm.address" size="mini" placeholder="请填写收件地址"></el-input>
                    </el-form-item>
                  </el-form>
                  <div style="
                      margin-top: 0.15rem;
                      text-align: right;
                      padding-right: 0.16rem;
                    ">
                    <el-button type="primary" size="mini" @click="saveChange('addAddressForm')">保存</el-button>
                  </div>
                  <el-tag size="mini" @click="resetSome" slot="reference" style="cursor: pointer">新增地址 <i
                      class="el-icon-plus"></i></el-tag>
                </el-popover>
              </el-row>
            </div>
          </el-form-item>
          <el-form-item label="快递公司" prop="exp_company">
            <el-select v-model="expruleForm.exp_company" placeholder="请选择快递公司" size="mini" style="width: 100%"
              filterable clearable>
              <el-option value="SFEXPRESS" label="顺丰"></el-option>
              <el-option value="STO" label="申通"></el-option>
              <el-option value="YTO" label="圆通"></el-option>
              <el-option value="ZTO" label="中通"></el-option>
              <el-option value="HTKY" label="汇通"></el-option>
              <el-option value="YUNDA" label="韵达"></el-option>
              <el-option value="TTKDEX" label="天天"></el-option>
              <el-option value="JD" label="京东快递"></el-option>
              <el-option value="ZJS" label="宅急送"></el-option>
              <el-option value="CHINAPOST" label="EMS"></el-option>
              <el-option value="INTMAIL" label="EMS国际"></el-option>
              <el-option value="DEPPON" label="德邦"></el-option>
              <el-option value="HTKY" label="百世快递"></el-option>
              <el-option value="JITU" label="极兔速递"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否下单" prop="is_now" v-if="
            expruleForm.sor === 's' && expruleForm.exp_company === 'SFEXPRESS'
          ">
            <el-checkbox v-model="expruleForm.is_now" size="mini" border @change="cancelOrder">是否现在下单</el-checkbox>
          </el-form-item>
          <el-form-item label="发件人" prop="name" v-if="expruleForm.is_now">
            <el-select v-model="expruleForm.name" filterable remote reserve-keyword placeholder="发件人" size="mini"
              clearable style="width: 100%" @change="getPersonPhone" @click.native="getSender">
              <el-option v-for="searchCompany in senderOptions" :key="searchCompany.id" :label="searchCompany.username"
                :value="searchCompany.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发件人手机" prop="sender_phone" v-if="expruleForm.is_now">
            <el-input type="number" v-model="expruleForm.sender_phone" size="mini" maxlength="11"
              show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="包裹数量" prop="quantity" v-if="expruleForm.is_now">
            <el-input type="number" v-model="expruleForm.quantity" size="mini" maxlength="2"
              placeholder="最多支持30件"></el-input>
          </el-form-item>
          <el-form-item label="快递费支付方式" prop="PayType"
            v-if="expruleForm.is_now && expruleForm.exp_company !== 'SFEXPRESS'">
            <el-radio-group v-model="expruleForm.PayType" size="mini" @change="clearChildren">
              <el-radio-button label="1">现付</el-radio-button>
              <el-radio-button label="2">到付</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="发货地址" prop="place" v-if="expruleForm.is_now">
            <el-radio-group v-model="expruleForm.place" size="mini">
              <el-radio label="FX">奉贤</el-radio>
              <el-radio label="JA">静安</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="快递单号" prop="exp_num" v-if="!expruleForm.is_now">
            <el-input v-model="expruleForm.exp_num" size="mini" placeholder="请输入快递单号"></el-input>
          </el-form-item>
          <el-form-item label="快递费支付" prop="buy" v-if="expruleForm.sor === 's'">
            <el-radio-group v-model="expruleForm.buy" size="mini">
              <el-radio-button label="w">我方</el-radio-button>
              <el-radio-button label="c">客户</el-radio-button>
              <el-radio-button label="d">到付</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="费用" prop="pay" v-if="expruleForm.sor === 's'">
            <el-input type="number" v-model="expruleForm.pay" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="快递费用收取" prop="is_buy" v-if="expruleForm.sor === 's' && expruleForm.buy === 'c'">
            <el-radio-group v-model="expruleForm.is_buy" size="mini" id="sign">
              <el-radio-button label="1">已收取</el-radio-button>
              <el-radio-button label="0">未收取(我方垫付)</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="快递手机号" prop="exp_phone" v-if="sf">
            <el-input v-model="expruleForm.exp_phone" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="快递手机号" prop="exp_phone" v-else>
            <el-input v-model="expruleForm.exp_phone" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="收件人(客户)" prop="receiver_s" v-if="expruleForm.sor === 's'">
            <el-select v-model="expruleForm.receiver_s" filterable remote reserve-keyword placeholder="选择收件地址自动添加收件人"
              size="mini" clearable :remote-method="searchInput" :loading="searchLoading" style="width: 100%" disabled>
              <el-option v-for="searchCompany in userOptions" :key="searchCompany.id" :label="'id:' +
                searchCompany.id +
                ' 昵称:' +
                searchCompany.name +
                ' 性别:' +
                searchCompany.sex
                " :value="searchCompany.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机(客户)" prop="receiver_phone" v-if="expruleForm.sor === 's'">
            <el-input v-model="expruleForm.receiver_phone" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="快递内容" prop="exp_content">
            <el-checkbox-group v-model="expruleForm.exp_content">
              <el-checkbox v-for="item in expContentOptions" :key="item.id" :label="item.category_name"
                name="exp_content"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input size="mini" type="textarea" v-model="expruleForm.remark" placeholder="快递备注,选择现在下单时快递公司可见！"
              style="white-space: pre"></el-input>
          </el-form-item>

          <div style="text-align: right">
            <el-button type="primary" size="mini" @click="submitForm('expruleForm')">录入</el-button>
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer :visible.sync="serviceInDrawer" direction="rtl" :before-close="handleClose_matter" size="40%"
      :append-to-body="true">
      <template slot="title">
        <span style="font-size: 0.38rem; font-weight: 700; color: #409eff">服务事项录入</span>
      </template>
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form :model="serviceInForm" :rules="rules_matter" ref="serviceInForm" label-width="100px">
          <el-form-item label="公司名称" prop="company_id">
            <el-select v-model="serviceInForm.company_id" filterable remote reserve-keyword placeholder="请输入公司名称筛选公司"
              size="mini" clearable :disabled="drawerTitle === '修改'" :remote-method="searchRemoteCompanyMethod"
              :loading="searchLoading" @change="getComUser" style="width: 100%">
              <el-option v-for="searchCompany in searchCompanies" :key="searchCompany.id"
                :label="searchCompany.company_name" :value="searchCompany.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="完成时间" prop="completed_at">
            <el-date-picker v-model="serviceInForm.completed_at" type="datetimerange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="typeInPickerOptions"
              :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%"
              size="mini">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="事项类型" prop="type">
            <el-checkbox v-model="serviceInForm.type" size="mini" label="w" border
              @change="clearNot">是否包含外勤</el-checkbox>
          </el-form-item>
          <el-form-item label="紧急程度" prop="urgent">
            <el-radio-group v-model="serviceInForm.urgent" size="mini">
              <el-radio-button label="1">正常</el-radio-button>
              <el-radio-button label="2">紧急</el-radio-button>
              <el-radio-button label="3">非常紧急</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="难易程度" prop="easy">
            <el-radio-group v-model="serviceInForm.easy" size="mini">
              <el-radio-button label="1">容易</el-radio-button>
              <el-radio-button label="2">正常</el-radio-button>
              <el-radio-button label="3">困难</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="事项分类" prop="categoryId">
            <el-select v-model="serviceInForm.categoryId" placeholder="请选择" clearable filterable size="mini"
              style="width: 100%" @click.native="loadCategory" @change="loadTitle">
              <el-option v-for="item in categoryIdOptions" :key="item.id" :label="item.category_name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="事项内容" prop="title">
            <el-select v-model="serviceInForm.title" placeholder="请选择" multiple clearable filterable size="mini"
              style="width: 100%" @change="changeTitle">
              <el-option v-for="item in titleIdOptions" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="内部可见" prop="detail_in">
            <el-input size="mini" type="textarea" v-model="serviceInForm.detail_in" placeholder="内容详情"
              style="white-space: pre"></el-input>
          </el-form-item>
          <el-form-item label="外部可见" prop="detail_out">
            <el-input size="mini" type="textarea" v-model="serviceInForm.detail_out" placeholder="内容详情"
              style="white-space: pre"></el-input>
          </el-form-item>
          <el-form-item label="是否分配" prop="is_dis">
            <el-checkbox v-model="serviceInForm.is_dis" size="mini" label="now" border
              @change="doSomeThing">现在分配</el-checkbox>
          </el-form-item>
          <el-form-item label="办理人" prop="doner_id" v-if="serviceInForm.is_dis && !serviceInForm.type">
            <el-select v-model="serviceInForm.doner_id" placeholder="请选择" size="mini" @click.native="loadAdminUser"
              filterable style="width: 100%" clearable>
              <el-option v-for="item in adminUserOptions" :key="item.id" :label="item.username" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="办理人" prop="doner_id_n" v-if="serviceInForm.is_dis && serviceInForm.type">
            <el-select v-model="serviceInForm.doner_id_n" placeholder="请选择" size="mini" @click.native="loadAdminUser"
              filterable style="width: 100%" clearable>
              <el-option v-for="item in adminUserOptions" :key="item.id" :label="item.username" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="外勤办理人" prop="doner_id_w" v-if="serviceInForm.type && serviceInForm.is_dis">
            <el-select v-model="serviceInForm.doner_id_w" placeholder="请选择" size="mini"
              @click.native="loadAdminUserForW" filterable style="width: 100%" clearable>
              <el-option v-for="item in adminUserOptions_w" :key="item.id" :label="item.username" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="办事地点" prop="address" v-if="serviceInForm.type && serviceInForm.is_dis">
            <el-select v-model="serviceInForm.address" placeholder="请选择" size="mini" @click.native="loadPlace"
              filterable style="width: 100%" clearable>
              <el-option v-for="item in placeOptions" :key="item.id" :label="item.places_title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="事项备注" prop="remark">
            <el-input size="mini" type="textarea" v-model="serviceInForm.remark" placeholder="内容详情"></el-input>
          </el-form-item>
          <el-form-item label="补充信息">
            <el-collapse v-model="activeNames_in">
              <el-collapse-item title="" name="1">
                <template slot="title">
                  <span style="color: #409eff">点击打开/隐藏</span>
                </template>
                <el-form-item label="订单号" prop="order_num">
                  <el-input v-model="serviceInForm.order_num" size="mini" placeholder="请输入订单号"
                    @input="getOrder_matter"></el-input>
                  <el-row v-if="orderData" :gutter="0">
                    <el-row>
                      <el-col>
                        <span>订单号：</span>
                        <span style="color: #409eff">{{
                          this.orderData.order_num
                        }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>创建时间：</span>
                        <span>{{ this.orderData.created_at }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>订单类型：</span>
                        <span style="color: #e6a23c">{{
                          this.orderData.order_type
                        }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>转化人：</span>
                        <span style="color: #67c23a">{{
                          this.orderData.convert_name
                        }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>订单总金额：</span>
                        <span style="color: #f56c6c">{{
                          this.orderData.total_amount
                        }}</span>
                      </el-col>
                    </el-row>
                  </el-row>
                </el-form-item>
                <el-form-item label="快递单号" prop="exp_num">
                  <el-input v-model="serviceInForm.exp_num" size="mini" placeholder="请输入快递单号"
                    @input="getExp"></el-input>
                  <el-row v-if="expData" :gutter="0">
                    <el-row>
                      <el-col :span="24">
                        <span>快递单号：</span>
                        <span style="color: #409eff">{{
                          this.expData.exp_num
                        }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>录入时间：</span>
                        <span>{{ this.expData.created_at }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>录入方式：</span>
                        <span style="color: #e6a23c">{{
                          this.expData.type
                        }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>录入人：</span>
                        <span style="color: #67c23a">{{
                          this.expData.exp_typeiner
                        }}</span>
                      </el-col>
                    </el-row>
                  </el-row>
                </el-form-item>
                <el-form-item label="快递公司" prop="exp_company">
                  <el-select v-model="serviceInForm.exp_company" placeholder="请选择快递公司" size="mini" style="width: 100%"
                    filterable clearable>
                    <el-option value="SFEXPRESS" label="顺丰"></el-option>
                    <el-option value="STO" label="申通"></el-option>
                    <el-option value="YTO" label="圆通"></el-option>
                    <el-option value="ZTO" label="中通"></el-option>
                    <el-option value="HTKY" label="汇通"></el-option>
                    <el-option value="YUNDA" label="韵达"></el-option>
                    <el-option value="TTKDEX" label="天天"></el-option>
                    <el-option value="JD" label="京东快递"></el-option>
                    <el-option value="ZJS" label="宅急送"></el-option>
                    <el-option value="CHINAPOST" label="EMS"></el-option>
                    <el-option value="INTMAIL" label="EMS国际"></el-option>
                    <el-option value="DEPPON" label="德邦"></el-option>
                    <el-option value="HTKY" label="百世快递"></el-option>
                    <el-option value="JITU" label="极兔速递"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="手机号" prop="exp_phone" :inline-message="true">
                  <el-input v-model="serviceInForm.exp_phone" size="mini" placeholder="请输入" maxlength="11"
                    show-word-limit clearable></el-input>
                </el-form-item>
                <el-form-item label="客户" prop="customer_name">
                  <el-input v-model="serviceInForm.customer_name" size="mini" placeholder="选择公司自动添加"
                    disabled></el-input>
                </el-form-item>
                <el-form-item label="共享人" prop="share_id">
                  <el-select v-model="serviceInForm.share_id" multiple placeholder="请选择" size="mini"
                    @click.native="loadShare" filterable style="width: 100%">
                    <el-option v-for="item in shareOptions" :key="item.id" :label="item.username" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-collapse-item>
            </el-collapse>
          </el-form-item>
          <el-form-item label="上传截图/文件" prop="url">
            <el-upload action="https://weixin.qiyehuo.com/api/servicein/upfile" :headers="headers" multiple
              ref="uploadMutiple" :file-list="fileList" :limit="limit" :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess" :on-change="handleAvatarChange" :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove">
              <el-button size="mini" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip" style="color: #909399; margin-top: -0.1rem">
                单次上传最多10个文件或图片
              </div>
            </el-upload>
            <div style="margin-top: 0.2rem">
              <span><i class="el-icon-s-opportunity" style="color: #fb894c">点击下方，Ctrl+v上传</i></span>
            </div>
            <div id="preview" @paste="handlePaste" style="
                border: 3px dashed #409eff;
                border-radius: 15px;
                text-indent: 2em;
              ">
              <span style="opacity: 0.5">先点击此处 再按Ctrl+V 粘贴至此处</span>
            </div>
          </el-form-item>
          <div style="text-align: right">
            <el-button type="primary" size="mini" @click="submitForm_matter('serviceInForm')">添加</el-button>
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer title="录入" :visible.sync="categoryIndrawer" :direction="direction" :before-close="handleCloseIn"
      size="40%" :append-to-body="true">
      <div style="padding: 0rem 0.2rem; margin-top: -17px">
        <el-form :model="categoryForm" :rules="rules_advice" ref="categoryForm" label-width="100px">
          <el-form-item label="公司名称" prop="companyId">
            <el-select v-model="categoryForm.companyId" filterable remote reserve-keyword placeholder="请输入公司名称筛选公司"
              size="mini" clearable :remote-method="searchRemoteCompanyMethodAdvice" :loading="searchLoadingTypein"
              style="width: 100%">
              <el-option v-for="searchCompany in searchCompaniesAdvice" :key="searchCompany.id"
                :label="searchCompany.company_name" :value="searchCompany.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="检查描述" prop="describe">
            <el-input size="mini" type="textarea" v-model="categoryForm.describe"></el-input>
          </el-form-item>
          <el-form-item label="是否存在问题" prop="problem" style="margin-bottom: 0.1rem">
            <el-radio-group v-model="categoryForm.problem" size="mini" @change="ifProblem">
              <el-radio-button :label="'0'">否</el-radio-button>
              <el-radio-button :label="1">是</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="" prop="ifNormal" v-if="categoryForm.problem === '0'">
            <el-checkbox v-model="categoryForm.ifNormal" size="mini">客户表达正常续费</el-checkbox>
          </el-form-item>
          <el-form-item label="" prop="cancelOrLost" v-if="categoryForm.problem === 1">
            <el-radio v-model="categoryForm.cancelOrLost" label="c">客户表达注销</el-radio>
            <el-radio v-model="categoryForm.cancelOrLost" label="l">流失预警</el-radio>
            <el-radio v-model="categoryForm.cancelOrLost" label="q">确认流失</el-radio>
          </el-form-item>
          <el-form-item label="问题类型" prop="categoryId" v-if="categoryForm.problem === 1">
            <el-select v-model="categoryForm.categoryId" multiple placeholder="请选择" clearable filterable size="mini"
              style="width: 100%">
              <el-option v-for="(item, index) in problemOptions" :key="index" :label="item.category_name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="责任人" prop="incharge" v-if="categoryForm.problem === 1">
            <el-select v-model="categoryForm.incharge" placeholder="请选择" clearable filterable size="mini"
              style="width: 100%">
              <el-option v-for="(item, index) in inchargeOptions" :key="index"
                :label="'(' + item.role + ')' + item.username" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="ETA处理时间" prop="done_at" v-if="categoryForm.problem === 1">
            <el-date-picker v-model="categoryForm.done_at" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="donePickerOptions"
              :default-time="['00:00:00', '23:59:59']" style="width: 100%" size="mini"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="上传截图" prop="url">
            <el-upload action="https://weixin.qiyehuo.com/api/quains/upscr" :headers="header_advice" multiple
              ref="uploadMutiple_advice" list-type="picture-card" :file-list="fileList_advice" :limit="limit_advice"
              accept="image/jpeg,image/jpg,image/png" :before-upload="beforeAvatarUpload_advice"
              :on-success="handleAvatarSuccess_advice" :on-change="handleAvatarChange_advice"
              :on-preview="handlePictureCardPreview_advice" :on-remove="handleRemove_advice">
              <i class="el-icon-plus"></i>
            </el-upload>
            <div style="margin-top: 0.2rem">
              <span><i class="el-icon-s-opportunity" style="color: #fb894c">点击下方，Ctrl+v上传</i></span>
            </div>
            <div id="preview_advice" @paste="handlePaste_advice" style="
                border: 3px dashed #409eff;
                border-radius: 15px;
                text-indent: 2em;
              ">
              <span style="opacity: 0.5">先点击此处 再按Ctrl+V 粘贴至此处</span>
            </div>
            <el-dialog :visible.sync="dialogVisible" :modal="false">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
          <div style="text-align: right">
            <el-button type="primary" size="mini" @click="submitForm_advice('categoryForm')"
              style="margin-right: 0.8rem">添加</el-button>
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer title="添加" :visible.sync="qualityDrawer" direction="rtl" :before-close="handleQualityClose" size="40%"
      :append-to-body="true">
      <div class="drawer-content">
        <el-form :model="qualityForm" ref="qualityForm" :rules="qualityRules" label-width="100px" size="mini">
          <el-form-item label="公司名称" prop="companyId">
            <el-select v-model="qualityForm.companyId" filterable remote reserve-keyword placeholder="请输入公司字号筛选公司"
              size="mini" clearable :remote-method="remoteCompanyMethod" :loading="loading">
              <el-option v-for="company in companies_quality" :key="company.id" :label="company.company_name"
                :value="company.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="责任部门" prop="branch_id">
            <el-select v-model="qualityForm.branch_id" filterable clearable placeholder="请选择">
              <el-option v-for="branch in branchs" :key="branch.id" :label="branch.name" :value="branch.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="责任人" prop="responsible_id">
            <el-select v-model="qualityForm.responsible_id" placeholder="责任人" filterable clearable size="mini">
              <el-option v-for="user in adminUsers" :key="user.id" :label="user.username" :value="user.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="原因" prop="reason">
            <el-select v-model="qualityForm.reason" multiple placeholder="责任人" filterable clearable size="mini">
              <el-option v-for="complaint in complaints" :key="complaint.id" :label="complaint.reason"
                :value="complaint.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="qualityForm.remark" type="textarea"></el-input>
          </el-form-item>
        </el-form>
        <div>
          <el-row>
            <el-col :span="24">
              <el-card shadow="hover">
                <el-upload multiple ref="upload" action="#" :headers="uploadHeader"
                  accept="image/png, image/jpeg, image/gif" :limit="5" :on-change="handleChange"
                  :on-remove="handleRemove_quality" :file-list="addImgList" list-type="picture" :auto-upload="false">
                  <el-link slot="trigger" type="primary">上传截图(最多可上传5张)</el-link>
                </el-upload>
              </el-card>
            </el-col>
          </el-row>
          <el-row style="padding-top: 0.4rem">
            <el-input v-paste="handleParse" type="textarea" placeholder="请点击此处，再粘贴复制的截图" />
          </el-row>
        </div>
        <el-row style="padding-top: 0.4rem; padding-bottom: 2rem; float: right">
          <el-col>
            <el-button type="primary" size="mini" @click="submitAddUpload('qualityForm')">添加</el-button>
          </el-col>
        </el-row>
      </div>
    </el-drawer>
    <el-dialog :visible.sync="dialpadVisible" title="拨号" :before-close="handleClose_dialpad" width="242px"
      :modal="false" :lock-scroll="false" :modal-append-to-body="false" v-dialpad-drag>
      <el-row class="mb-10">
        <el-col :span="24">
          <el-input v-model="phoneNum" size="medium"></el-input>
        </el-col>
      </el-row>
      <el-row class="num-cell">
        <el-col :span="8">
          <div class="num" @click="clickNum(1)">1</div>
        </el-col>
        <el-col :span="8">
          <div class="num" @click="clickNum(2)">2</div>
        </el-col>
        <el-col :span="8">
          <div class="num" @click="clickNum(3)">3</div>
        </el-col>
      </el-row>
      <el-row class="num-cell">
        <el-col :span="8">
          <div class="num" @click="clickNum(4)">4</div>
        </el-col>
        <el-col :span="8">
          <div class="num" @click="clickNum(5)">5</div>
        </el-col>
        <el-col :span="8">
          <div class="num" @click="clickNum(6)">6</div>
        </el-col>
      </el-row>
      <el-row class="num-cell">
        <el-col :span="8">
          <div class="num" @click="clickNum(7)">7</div>
        </el-col>
        <el-col :span="8">
          <div class="num" @click="clickNum(8)">8</div>
        </el-col>
        <el-col :span="8">
          <div class="num" @click="clickNum(9)">9</div>
        </el-col>
      </el-row>
      <el-row class="num-cell">
        <el-col :span="8">
          <div class="num" @click="clickNum('*')">*</div>
        </el-col>
        <el-col :span="8">
          <div class="num" @click="clickNum(0)">0</div>
        </el-col>
        <el-col :span="8">
          <div class="num" @click="clickNum('#')">#</div>
        </el-col>
      </el-row>
      <el-row class="num-cell">
        <el-col :span="8">
          <div class="num" @click="record"><i class="el-icon-s-grid"></i></div>
        </el-col>
        <el-col :span="8">
          <div class="num" @click="call">
            <i class="el-icon-phone-outline"></i>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="num" @click="backNum"><i class="el-icon-back"></i></div>
        </el-col>
      </el-row>
    </el-dialog>
    <el-drawer title="线索录入" :visible.sync="clueDrawer" direction="rtl" :before-close="handleAddDrawerBeforeClose"
      :append-to-body="true" size="40%">
      <div class="m-tabs-content" id="clue_style">
        <div class="tabs_line">
          <div class="lines"></div>
          <h3 class="tabs-title">线索信息</h3>
        </div>
        <el-divider></el-divider>
        <el-row style="margin-bottom:0.28rem">
          <el-col :span="6" class="m-label">选择园区：</el-col>
          <el-col :span="10">
            <el-select v-model="addForm_clue.garden" placeholder="请选择" :size="inputSize" clearable>
              <el-option :value="1" label="上海园区"></el-option>
              <el-option :value="2" label="南京园区"></el-option>
              <el-option :value="3" label="徐州园区"></el-option>
              <el-option :value="4" label="其他园区"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-bottom:0.28rem">
          <el-col :span="6" class="m-label">线索状态：</el-col>
          <el-col :span="10">
            <el-select v-model="addForm_clue.status" @change="selectStatus" placeholder="请选择" :size="inputSize"
              clearable>
              <el-option :value="0" label="未认领"></el-option>
              <el-option :value="4" label="成单待确认"></el-option>
              <el-option :value="3" label="无法联系"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-bottom:0.28rem">
          <el-col :span="6" class="m-label">客户来源：</el-col>
          <el-col :span="10">
            <el-select :filterable="true" v-model="addForm_clue.customer_source" placeholder="请选择" :size="inputSize"
              clearable>
              <el-option v-for="item in customerSource" :key="item.source_id" :label="item.source_name"
                :value="item.source_id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-bottom:0.28rem">
          <el-col :span="6" class="m-label">客户姓名：</el-col>
          <el-col :span="10"><el-input v-model="addForm_clue.custom_name" :size="inputSize"
              clearable></el-input></el-col>
        </el-row>
        <el-row style="margin-bottom:0.28rem">
          <el-col :span="6" class="m-label">客户手机：</el-col>
          <el-col :span="10"><el-input maxlength="11" v-model="addForm_clue.custom_phone" :size="inputSize"
              clearable></el-input></el-col>
        </el-row>
        <el-row style="margin-bottom:0.28rem">
          <el-col :span="6" class="m-label">微信号：</el-col>
          <el-col :span="10"><el-input v-model="addForm_clue.wechat_account" :size="inputSize"
              clearable></el-input></el-col>
        </el-row>
        <el-row style="margin-bottom:0.28rem">
          <el-col :span="6" class="m-label">所属省市：</el-col>
          <el-col :span="10">
            <el-cascader ref="cascaderAddr" style="width: 100%" v-model="value" :props="optionProps" :options="options"
              :size="inputSize" @change="handleChange_clue"></el-cascader>
          </el-col>
        </el-row>
        <el-row style="margin-bottom:0.28rem">
          <el-col :span="6" class="m-label">群聊ID：</el-col>
          <el-col :span="10"><el-input v-model="addForm_clue.group_chat_id" :size="inputSize"
              clearable></el-input></el-col>
        </el-row>
        <el-row style="margin-bottom:0.28rem">
          <el-col :span="6" class="m-label">页面标题：</el-col>
          <el-col :span="10"><el-input v-model="addForm_clue.page_title" :size="inputSize"
              clearable></el-input></el-col>
        </el-row>
        <el-row style="margin-bottom:0.28rem" v-show="addForm_clue.status === 4">
          <el-col :span="6" class="m-label">转化人：</el-col>
          <el-col :span="10">
            <el-select :filterable="true" v-model="addForm_clue.uid" placeholder="请选择" :size="inputSize" clearable>
              <el-option v-for="(item, index) in ConversionPeople" :key="index" :label="item.username" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-bottom:0.28rem">
          <el-col :span="6" class="m-label">咨询分类：</el-col>
          <el-col :span="10">
            <el-select :filterable="true" v-model="addForm_clue.refer_cate" placeholder="请选择" :size="inputSize"
              clearable>
              <el-option v-for="item in serverTypes" :key="item.server_id" :label="item.server_name"
                :value="item.server_id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-bottom:0.28rem">
          <el-col :span="6" class="m-label">是否分配线索：</el-col>
          <el-col :span="10" class="m-label">
            <el-switch v-model="switchValue" :width="40" @change="switchChange" active-text="">
            </el-switch>
          </el-col>
        </el-row>
        <el-row style="margin-bottom:0.28rem" v-show="addForm_clue.type">
          <el-col :span="6" class="tr m-label text_right">公司分配:</el-col>
          <el-col :span="10">
            <el-select :filterable="true" v-model="addForm_clue.uid" placeholder="请选择分配人员" size="mini" clearable>
              <el-option v-for="(item, index) in ConversionPeople" :key="index" :label="item.username" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-bottom:0.28rem">
          <el-col :span="6" class="m-label">咨询关键内容：</el-col>
          <el-col :span="18">
            <el-input style="min-height: 1rem" :autosize="textareaSize" type="textarea"
              v-model="addForm_clue.refer_content" size="mini" clearable></el-input>
          </el-col>
        </el-row>
      </div>
      <el-row class="bottom-btn">
        <el-button @click="handleSave_clue" size="mini" type="primary">保存</el-button>
      </el-row>
    </el-drawer>
  </div>
</template>

<script>
import BenzAMRRecorder from 'benz-amr-recorder'
let amr = new BenzAMRRecorder()
import { common } from '../../static/mixins/common'
import { mapState } from "vuex";
const loadAutoHyperHost = () => import('@/config').then(module => module.AutoHyperfHost);
import { socketIOAddress } from '@/config/socketIOAddress'
import io from 'socket.io-client'
import 'import-notify-ysy01'
export default {
  name: 'HeadNav',
  components: {
    'export_phone': () => import('@/common/components/ExportPhone'),
    // ImportProgress
  },
  props: {
    user: Object,
    salers: Array,
    headNode: Array
  },
  mixins: [common],
  data() {
    let checkPhone = (rule, value, callback) => {
      if (value !== '') {
        let reg = /^1[3456789]\d{9}$/
        if (!reg.test(value)) {
          callback(new Error('请输⼊有效的⼿机号码'))
        }
      }
      callback()
    }
    let checkExpNum = (rule, value, callback) => {
      const title = /^[A-Z]*[a-z]*[0-9]*$/
      if (!title.test(value)) {
        callback(new Error('快递单号只能是字母，数字！'))
      } else {
        callback()
      }
    }
    let categoryId = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请选择问题类型！'))
      }
      callback()
    }
    let checkIncharge = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请选择责任人！'))
      }
      callback()
    }
    let checkDoneat = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请选择ETA处理时间！'))
      }
      callback()
    }
    let checkdesc = (rule, value, callback) => {
      if (value.length > 500) {
        return callback(new Error('输入过长！'))
      }
      if (value.length === 0) {
        return callback(new Error('请输入描述内容！'))
      }
      callback()
    }
    let checkproblem = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请选择是否有问题！'))
      }
      callback()
    }
    let checkCompany = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请选择公司！'))
      }
      callback()
    }
    return {
      encryptPhoneDialog: false,
      decryptPhoneDialog: false,
      company_name: '',
      Binding: false,
      psId: '',
      value: '',
      pageNodes: [],
      textareaSize: { minRows: 6, maxRows: 10 },
      serverTypes: [],
      custom_city_name: '上海市/上海市',
      options: [],
      optionProps: {
        value: 'id',
        label: 'Provincial',
        children: 'son'
      },
      customerSource: [],
      ConversionPeople: [],
      switchValue: false,
      addForm_clue: {
        customer_source: '',
        garden: 1,
        status: 0,
        custom_name: '',
        custom_phone: '',
        wechat_account: '',
        custom_province: '',
        custom_city: '',
        custom_city_name: '',
        group_chat_id: '',
        page_title: '',
        im_name: '',
        refer_cate: 1,
        refer_content: '',
        conversion_people: '',
        uid: '',
        type: 0
      },
      clueDrawer: false,
      phoneNum: '',
      wavSrc: '/static/13685.wav',
      wavPlayIng: false,
      dialpadVisible: false,
      formData: null,
      addImgList: [],
      uploadHeader: {
        Authorization: 'Bearer ' + localStorage.tenantToken
      },
      complaints: [],
      adminUsers: [],
      branchs: [],
      companies_quality: [],
      qualityRules: {
        companyId: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        branch_id: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        remark: [{ required: true, message: '请输入备注', trigger: 'blur' }]
      },
      qualityForm: {
        companyId: null,
        branch_id: null,
        responsible_id: null,
        reason: [],
        remark: ''
      },
      qualityDrawer: false,
      dialogImageUrl: '',
      dialogVisible: false,
      limit_advice: 10,
      fileList_advice: [],
      header_advice: {
        Authorization: localStorage.getItem('token')
      },
      donePickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      inchargeOptions: [],
      problemOptions: [],
      searchCompaniesAdvice: [],
      searchCompaniesHead: [],
      rules_advice: {
        categoryId: [
          {
            validator: categoryId,
            trigger: 'blur'
          }
        ],
        incharge: [
          {
            validator: checkIncharge,
            trigger: 'blur'
          }
        ],
        done_at: [
          {
            validator: checkDoneat,
            trigger: 'blur'
          }
        ],
        describe: [
          {
            validator: checkdesc,
            trigger: 'blur'
          }
        ],
        problem: [
          {
            validator: checkproblem,
            trigger: 'blur'
          }
        ],
        companyId: [
          {
            validator: checkCompany,
            trigger: 'blur'
          }
        ]
      },
      needUrl_advice: [],
      categoryForm: {
        categoryId: [],
        problem: '',
        describe: '',
        companyId: '',
        incharge: '',
        done_at: [],
        cancelOrLost: '',
        ifNormal: ''
      },
      categoryIndrawer: false,
      rules_matter: {
        company_id: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        completed_at: [
          { required: true, message: '请输入完成时间', trigger: 'blur' }
        ],
        categoryId: [
          { required: true, message: '请选择事项分类', trigger: 'blur' }
        ],
        title: [{ required: true, message: '请选择事项内容', trigger: 'blur' }],
        detail_in: [
          { max: 2000, message: '长度最多2000个字符', trigger: 'blur' }
        ],
        detail_out: [
          { max: 2000, message: '长度最多2000个字符', trigger: 'blur' }
        ],
        order_num: [
          { max: 255, message: '长度最多255个字符', trigger: 'blur' }
        ],
        doner_id: [
          { required: true, message: '请选择办理人', trigger: 'blur' }
        ],
        doner_id_w: [
          { required: true, message: '请选择办理人(外勤)', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请选择办事地点', trigger: 'blur' }
        ]
      },
      activeNames_in: [],
      fileNameList: [],
      limit: 10,
      headers: {
        Authorization: localStorage.getItem('token')
      },
      shareOptions: [],
      placeOptions: [],
      adminUserOptions_w: [],
      adminUserOptions: [],
      watchDetail_in_arr: [],
      editForm: {
        exp_company: '',
        exp_phone: '',
        is_dis: '',
        company_id: '',
        order_num: '',
        completed_at: '',
        type: '',
        categoryId: '',
        title: [],
        detail_in: '',
        detail_out: '',
        cate: {},
        title_name: '',
        share_id: '',
        exp_num: '',
        customer_id: '',
        customer_name: '',
        urgent: '',
        easy: '',
        doner_id: '',
        address: '',
        remark: '',
        doner_id_w: ''
      },
      titleIdOptions: [],
      categoryIdOptions: [],
      typeInPickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24
        }
      },
      searchCompanies: [],
      drawerTitle: '',
      serviceInForm: {
        doner_id_n: '',
        exp_company: '',
        exp_phone: '',
        is_dis: '',
        company_id: '',
        order_num: '',
        completed_at: '',
        type: '',
        categoryId: '',
        title: [],
        detail_in: '',
        detail_out: '',
        cate: {},
        title_name: '',
        share_id: '',
        exp_num: '',
        customer_id: '',
        customer_name: '',
        urgent: '',
        easy: '',
        doner_id: '',
        address: '',
        remark: '',
        doner_id_w: ''
      },
      change: false,
      needUrl: [],
      fileList: [],
      orderData: '',
      expData: null,
      customerData: null,
      serviceInDrawer: false,
      addressProOptions: [],
      addressCityOptions: [],
      addressTownOptions: [],
      editAddressDialog: false,
      editAddressForm: {
        addressee: '',
        address_phone: '',
        address: '',
        receiver_place_pro: '',
        receiver_place_city: '',
        receiver_place_town: ''
      },
      editAddressId: null,
      sIndex: null,
      signExpContentOptions: [],
      expContentOptions: [],
      userOptions: [],
      searchArr: {
        order_code: '',
        company_id: '',
        exp_company: '',
        created_at: '',
        updated_at: '',
        exp_typeiner: '',
        exp_status: '',
        exp_type: '',
        sor: '',
        other: '',
        buy: '',
        is_buy: '',
        businessC: '',
        kefuC: '',
        jizhangC: '',
        taxC: '',
        kaipiaoC: '',
        leaderC: ''
      },
      senderOptions: [],
      secondLoadId: null,
      searchLoadingTypein: false,
      searchCompaniesTypein: [],
      searchLoading: false,
      receiverOptions: [],
      rules: {
        pay: [{ required: true, message: '请填写费用', trigger: 'blur' }],
        is_buy: [
          { required: true, message: '请选择快递费是否收取', trigger: 'blur' }
        ],
        buy: [
          { required: true, message: '请选择快递费支付方', trigger: 'blur' }
        ],
        receiver_phone: [
          { required: true, message: '请填写手机(客户)', trigger: 'blur' }
        ],
        receiver_s: [
          { required: true, message: '请填写收件人(客户)', trigger: 'blur' }
        ],
        company_id: [{ message: '请选择公司名称', trigger: 'blur' }],
        exp_num: [
          { required: true, message: '请输入快递单号', trigger: 'blur' },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          },
          { validator: checkExpNum, trigger: 'blur' }
        ],
        sor: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        exp_phone: [
          {
            validator: checkPhone,
            trigger: 'blur'
          }
        ],
        exp_company: [
          { required: true, message: '请选择快递公司', trigger: 'change' }
        ]
      },
      fileLists: [],
      expruleForm: {
        wxOrder: '',
        order_code: '',
        PayType: '',
        quantity: '',
        receiver_place_pro: '',
        receiver_place_city: '',
        receiver_place_town: '',
        receiver_address: '',
        sender_phone: '',
        name: '',
        place: '',
        is_now: '',
        exp_num: '',
        company_id: '',
        company_name: '',
        exp_company: '',
        exp_phone: '',
        domains: [
          {
            value: ''
          }
        ],
        exp_content: [],
        exp_receiver: '',
        delivery: false,
        sor: '',
        receiver_phone: '',
        receiver_s: '',
        pay: '',
        buy: '',
        remark: '',
        is_buy: ''
      },
      placeRadio: false,
      typein: false,
      cIndex: null,
      userAdressOptions: '',
      addAddressForm: {
        addressee: '',
        address_phone: '',
        address: '',
        receiver_place_pro: '',
        receiver_place_city: '',
        receiver_place_town: ''
      },
      addressRules: {
        addressee: [
          { required: true, message: '请输入收件人', trigger: 'blur' }
        ],
        address_phone: [
          { required: true, message: '请输入收件人手机号', trigger: 'blur' },
          { validator: checkPhone, trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入收件人姓名', trigger: 'blur' }
        ]
      },
      direction: 'rtl',
      expManageIndrawer: false,
      personnel: [],
      features: [],
      regTypes: [],
      mealSingles: [],
      orderRegs: [],
      moneyInCateOptions: '',
      companies_o: '',
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 10 // 每页显示条数
      },
      textareaSize2: {
        minRows: 2,
        maxRows: 4
      },
      users: [],
      bussiness_content: [],
      inputSize: 'small',
      companies: '',
      loading: false,
      addData: {
        company_id: '',
        bussin_content: [],
        urgency: 1,
        remark: '',
        uid: ''
      },
      BODialog: false,
      mover: false,
      sendMsgForm: {
        phone: '',
        msg: ''
      },
      encryptPhoneForm: {
        phone: '',
        encryptedPhone: ''
      },
      decryptPhoneForm: {
        phone: '',
        encryptedPhone: ''
      },
      sendMsgDialog: false,
      userinfo: {
        username: '?'
      },
      fromOptions: [],
      callPhone: null,
      addComdVisible: false,
      addComForm: {
        company_name: '',
        saler_id: null
      },
      addComRules: {
        company_name: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        saler_id: [
          { required: true, message: '请选择业务员', trigger: 'blur' }
        ]
      },
      sendMsgFormRules: {
        phone: [
          { validator: checkPhone, trigger: 'blur' },
          { required: true, message: '请填写手机号码', trigger: 'blur' }
        ],
        msg: [
          { required: true, message: '请输入短信内容', trigger: 'blur' },
          { max: 100, message: '最多100个字！', trigger: 'blur' }
        ]
      },
      encryptPhoneFormRules: {
        phone: [
          { validator: checkPhone, trigger: 'blur' },
          { required: true, message: '请填写手机号码', trigger: 'blur' }
        ],
      },
      decryptPhoneFormRules: {
        encryptedPhone: [
          { required: true, message: '请填写手机号密文', trigger: 'blur' }
        ],
      },
      salerData: [],
      headNodeData: [],
      sources: [],
      flagData: [],
      flagDrawer: false,
      exportPhoneDialog: false,
      importNotifyInstance: null,
      socket: null,
    }
  },
  computed: {
    ...mapState({
      imUnreadCount: state => state.imUnreadCount
    }),
    userName: {
      get: function () {
        return this.userinfo.username.substr(0, 1)
      }
    },
    whetherOnline: {
      get: function () {
        return this.userinfo.whether_online
      }
    },
    sf: function () {
      if (this.expruleForm.exp_company === 'SFEXPRESS') {
        this.rules.exp_phone = [
          { required: true, message: '请输入手机号', trigger: 'change' }
        ]
        return true
      } else {
        this.rules.exp_phone = [{ message: '请输入手机号', trigger: 'change' }]
      }
    }
  },
  watch: {
    user: function (val) {
      this.userinfo = val || { username: '？' }
    },
    salers: function (val) {
      this.salerData = val || []
    },
    headNode: function (val) {
      this.headNodeData = val || []
    },
    watchDetail_in_arr: function (n, old) {
      this.serviceInForm.detail_in = n.join('')
      this.serviceInForm.detail_out = n.join('')
    },
    phoneNum(val) {
      this.phoneNum = this.phoneNum.replace(/[^\d*#/]/g, '')
    }
  },
  methods: {
    // flagPannel(uid) {
    //   this.flagDrawer = true
    //   this.$axios.get('/api/admin/check/get_user_flag?user_id=' + uid)
    //     .then((res) => {
    //       const { data } = res
    //       if (data.code === 0) {

    //         this.flagData = data.data.flagData
    //       }
    //     })
    // },
    chooseCompany(company_id) {
      location.href = '/company_set?company_id=' + company_id
    },
    provinceCityData() {
      this.$axios.get('/api/thread/cities')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            for (let a = 0; a < data.data.length; a++) {
              this.options.push(data.data[a])
            }
          }
        })
    },
    handleAddDrawerClose_clue() {
      this.clueDrawer = false
      this.clearAddData_clue()
    },
    handleSave_clue() {
      let phone = /^1[3|4|5|7|6|8|9][0-9]{9}$/
      if (!this.addForm_clue.custom_phone && !this.addForm_clue.wechat_account) {
        this.$message.error('客户手机或微信号不能为空')
        return
      }
      if (this.addForm_clue.custom_phone !== '') {
        if (!phone.test(this.addForm_clue.custom_phone)) {
          this.$message.error('客户手机号格式不正确')
          return
        }
      }
      if (!this.addForm_clue.custom_province) {
        this.$message.error('请选择所属省市')
        return
      }
      if (!this.addForm_clue.group_chat_id) {
        this.$message.error('群聊ID不能为空')
        return
      }
      if (this.addForm_clue.status === 2) {
        if (!this.addForm_clue.uid) {
          this.$message.error('转化人不能为空')
          return
        }
      }
      if (!this.addForm_clue.refer_cate) {
        this.$message.error('请选择咨询分类')
        return
      }
      if (!this.addForm_clue.refer_content) {
        this.$message.error('咨询关键内容不能为空')
        return
      }
      let that = this
      this.$axios.post('/api/thread/imcreate', that.addForm_clue)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            that.handleAddDrawerClose_clue()
            that.$message.success(data.msg)
          } else {
            that.$message.error(data.msg)
          }
        })
    },
    switchChange(value) {
      this.addForm_clue.uid = value ? this.addForm_clue.uid : ''
      this.addForm_clue.type = value ? 1 : 0
    },
    handleChange_clue(value) {
      let input = this.$refs['cascaderAddr'].getCheckedNodes()[0].pathLabels
      this.addForm_clue.custom_city_name = input[0] + '/' + input[1]
      this.custom_city_name = input[0] + '/' + input[1]
      this.addForm_clue.custom_province = value[0]
      this.addForm_clue.custom_city = value[1]
    },
    handleClueOpen() {
      let that = this
      this.provinceCityData()
      this.handelGetOrders_clue()
      that.addForm_clue.custom_city_name = that.custom_city_name
      that.addForm_clue.custom_province = that.value[0]
      that.addForm_clue.custom_city = that.value[1]
      that.addForm_clue.refer_cate = 1
      this.clueDrawer = true
    },
    handelGetOrders_clue(groupChatId, imName, referCate, startTime, endTime, Garden, communicatAt, communicatTimes) {
      this.$axios.get('/api/thread/show?page=' + 1 + '&perPage=' + 10, {
        params: {
          group_chat_id: groupChatId,
          im_name: imName,
          refer_cate: referCate,
          start_time: startTime,
          end_time: endTime,
          garden: Garden,
          communicat_at: communicatAt,
          communicat_times: communicatTimes,
          search: ''
        }
      })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.serverTypes = data.data.serverTypes
            this.pageNodes = data.data.pageNodes
            this.ConversionPeople = data.data.users
            this.customerSource = data.data.customer_source
          }
        })
    },
    selectStatus(val) {
      if (val === 4) {
        for (let a = 0; a < this.ConversionPeople.length; a++) {
          if (this.ConversionPeople[a].id === this.user.id) {
            this.addForm_clue.uid = this.ConversionPeople[a].id
          }
        }
      } else {
        this.addForm_clue.uid = ''
      }
    },
    clearAddData_clue() {
      this.addForm_clue.status = 0
      this.addForm_clue.custom_name = ''
      this.addForm_clue.custom_phone = ''
      this.addForm_clue.wechat_account = ''
      this.addForm_clue.im_name = ''
      this.addForm_clue.page_title = ''
      this.addForm_clue.group_chat_id = ''
      this.addForm_clue.refer_cate = ''
      this.addForm_clue.refer_content = ''
      this.addForm_clue.uid = ''
      this.switchValue = false
      this.addForm_clue.type = 0
    },
    handleAddDrawerBeforeClose(done) {
      this.$confirm('确认关闭?')
        .then(_ => {
          this.clearAddData_clue()
          done()
        })
        .catch(_ => { })
    },
    openDialpadDialog() {
      this.dialpadVisible = true
    },
    clickNum(num) {
      this.phoneNum += num
      let that = this
      if (!that.wavPlayIng) {
        that.wavPlayIng = true
        amr = new BenzAMRRecorder()
        amr.initWithUrl(this.wavSrc).then(function () {
          amr.play()
        })
        amr.onEnded(function () {
          that.wavPlayIng = false
          console.log('播放完毕')
        })
      }
    },
    record() {
      this.$message.success('录音自动开启，无需手动操作')
    },
    call() {
      let regPhone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/

      if (!regPhone.test(this.phoneNum)) {
        this.$message.error('手机号格式错误')
        return
      }

      this.$axios.post('/api/admin/call_logs/' + this.phoneNum).then(res => {
        let { data } = res
        if (data.code === 0) {
          this.$message.success('调用成功，请注意接听来电')
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    backNum() {
      this.phoneNum = this.phoneNum.slice(0, this.phoneNum.length - 1)
    },
    handleClose_dialpad(done) {
      this.phoneNum = ''
      done()
    },
    submitAddUpload(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.addImgList.length > 0) {
            this.addImgList.forEach(file =>
              this.formData.append('file[]', file.raw)
            )
          }
          for (let key in this.addForm) {
            this.formData.append(key, this.addForm[key])
          }
          this.$axios
            .post('/api/admin/we_chat_qualities', this.formData)
            .then(res => {
              let { data } = res
              if (data.code === 0) {
                this.$message.success(data.msg)
                this.formData = null
                this.addDrawer = false
                this.$refs[formName].resetFields()
                this.addImgList = []
              }
            })
        }
      })
    },
    handleParse(e) {
      let file = null
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf('image') > -1
      ) {
        file = e.clipboardData.items[0].getAsFile()
        let reader = new FileReader()
        reader.readAsDataURL(file)
        let that = this
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: 'ready',
            url: e.target.result
          }

          if (that.addImgList.length < 5) {
            that.addImgList.push(fileObj)
          } else {
            that.$message.error('最多可以上传5张')
          }
        }
      } else {
        this.$message.warning('上传的文件必须为图片')
      }
    },
    handleRemove_quality(file, fileList) {
      this.addImgList = fileList
      this.formData = null
      this.formData = new FormData()
      this.addImgList.forEach(file => this.formData.append('file[]', file.raw))
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key])
      }
    },
    handleChange(file, fileList) {
      this.addImgList = fileList
    },
    handleQualityOpen() {
      this.getPageData()
      this.qualityDrawer = true
    },
    getPageData() {
      this.$axios
        .get('/api/admin/we_chat_qualities?page=' + 1 + '')
        .then(res => {
          let { data } = res
          if (data.code === 0) {
            this.pageData = data.data.pageData.data
            this.pageOption.total = data.data.pageData.total
            this.branchs = data.data.departments
            this.adminUsers = data.data.adminUsers
            this.complaints = data.data.complaints
            this.calculate = data.data.countData
          }
        })
    },
    remoteCompanyMethod(query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.searchItemCompanys(query)
        }, 200)
      } else {
        this.companies_quality = []
      }
    },
    searchItemCompanys(query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.companies_quality = data.data.companies
        }
      })
    },
    handleQualityClose(done) {
      this.formData = null
      this.$refs['qualityForm'].resetFields()
      done()
    },
    submitForm_advice(formName) {
      if (!this.categoryForm.companyId) {
        this.$message.error('请选择公司！')
        return false
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.categoryForm.file = this.needUrl_advice
          this.$axios
            .post('api/quains/store', this.categoryForm)
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$refs.categoryForm.resetFields()
                this.$refs.uploadMutiple_advice.clearFiles()
                this.needUrl_advice = []
                this.$message.success(data.msg)
                this.categoryIndrawer = false
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          return false
        }
      })
    },
    // 监听粘贴操作
    handlePaste_advice(event) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null
      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持本地')
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          file = items[i].getAsFile()
          break
        }
      }
      if (!file) {
        this.$message.error('粘贴内容非图片')
        return
      }
      if (this.fileList_advice.length >= this.limit_advice) {
        this.$message.error(`上传文件数量不能超过 ${this.limit_advice} 个!`) // 图片数量超出
        return
      }
      this.$refs.uploadMutiple_advice.handleStart(file) // 将粘贴过来的图片加入预上传队列
      this.$refs.uploadMutiple_advice.submit() // 提交图片上传队列
    },
    handleRemove_advice(file, fileList) {
      this.needUrl_advice.map((item, index) => {
        if (item.uid === file.uid) {
          this.needUrl_advice.splice(index, 1)
        }
      })
      this.fileList_advice = fileList
    },
    handlePictureCardPreview_advice(file) {
      this.dialogVisible = true
      this.dialogImageUrl = file.url
    },
    handleAvatarChange_advice(res, file) {
      this.fileList_advice = file
    },
    handleAvatarSuccess_advice(res, file) {
      if (res.code === 1) {
        this.needUrl_advice.push({
          url: res.url,
          name: file.name,
          uid: file.uid
        })
      }
    },
    beforeAvatarUpload_advice(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传图片格式为JPG或PNG!')
        return
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }
    },
    loadIncharge() {
      if (!this.categoryForm.companyId) {
        this.$message.error('请先选择公司！')
        return false
      }
      this.$axios
        .get('api/quains/incharge?company_id=' + this.categoryForm.companyId)
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.inchargeOptions = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    loadCategory_advice() {
      this.$axios
        .get('api/quains/getcate')
        .then(({ data }) => {
          if (data.code === 1) {
            this.problemOptions = data.data
          }
        })
        .catch()
    },
    ifProblem(val) {
      if (val === 1) {
        this.loadCategory_advice()
        this.loadIncharge()
        this.categoryForm.ifNormal = false
      }
      if (val === '0') {
        this.categoryForm.cancelOrLost = ''
        this.categoryForm.incharge = null
        this.categoryForm.done_at = null
        this.categoryForm.categoryId = null
      }
    },
    searchArrItemCompanysAdvice(query) {
      this.$axios.get('/api/admin/searchCompany_a?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.searchCompaniesAdvice = data.data.companies
        }
      })
    },
    searchArrItemCompanysHead(query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.searchCompaniesHead = data.data.companies
        }
      })
    },
    searchRemoteCompanyMethodAdvice(query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchArrItemCompanysAdvice(query)
        }, 200)
      } else {
        this.searchCompaniesAdvice = []
      }
    },
    searchRemoteCompanyMethodHead(query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchArrItemCompanysHead(query)
        }, 200)
      } else {
        this.searchCompaniesHead = []
      }
    },
    handleCloseIn(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.$refs.categoryForm.resetFields()
          this.$refs.uploadMutiple_advice.clearFiles()
          this.needUrl_advice = []
          done()
        })
        .catch(_ => { })
    },
    handleAdviceOpen() {
      this.loadCategory_advice()
      this.categoryIndrawer = true
    },
    handleMatterOpen() {
      this.serviceInDrawer = true
    },
    doSomeThing(val) {
      if (!val) {
        this.serviceInForm.doner_id = ''
        this.serviceInForm.doner_id_n = ''
        this.serviceInForm.doner_id_w = ''
        this.serviceInForm.address = ''
      }
    },
    submitForm_matter(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.serviceInForm.file = this.needUrl
          this.$axios
            .post('api/servicein/store', this.serviceInForm)
            .then(({ data }) => {
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.$refs.serviceInForm.resetFields()
                this.orderData = null
                this.expData = null
                this.customerData = null
                this.needUrl = []
                this.fileList = []
                this.serviceInDrawer = false
                this.change = false
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          return false
        }
      })
    },
    // 监听粘贴操作
    handlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null
      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持本地')
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        file = items[i].getAsFile()
      }
      if (this.fileList.length >= this.limit) {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`) // 图片数量超出
        return
      }
      this.$refs.uploadMutiple.handleStart(file) // 将粘贴过来的图片加入预上传队列
      this.$refs.uploadMutiple.submit() // 提交图片上传队列
    },
    handleRemove(file, fileList) {
      this.needUrl.map((item, index) => {
        if (item.uid === file.uid) {
          this.needUrl.splice(index, 1)
        }
      })
      this.fileList = fileList
      this.change = true
    },
    handlePictureCardPreview(file) {
      this.fileNameList = file.name
    },
    handleAvatarChange(res, file) {
      this.fileList = file
      this.change = true
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 1) {
        this.needUrl.push({ url: res.url, name: file.name, uid: file.uid })
      }
    },
    beforeAvatarUpload(file) {
      const isLt100M = file.size / (1024 * 100) < 100
      if (!isLt100M) {
        this.$message.error('上传总大小不能超过 100MB!')
        return false
      }
    },
    loadShare() {
      this.$axios
        .get('api/expmanage/getreceiver')
        .then(({ data }) => {
          if (data.code === 1) {
            this.shareOptions = data.data
          }
        })
        .catch()
    },
    getExp(val) {
      if (val.length === 0) return false
      this.$axios
        .get('api/servicein/getexp?exp_num=' + val)
        .then(({ data }) => {
          if (data.code === 1) {
            this.expData = data.data
          }
        })
        .catch()
    },
    getOrder_matter(val) {
      if (val.length === 0) return false
      this.$axios
        .get('api/servicein/getorder?order_num=' + val)
        .then(({ data }) => {
          if (data.code === 1) {
            this.orderData = data.data
          }
        })
        .catch()
    },
    loadPlace() {
      this.$axios
        .get('api/outdis/getplace')
        .then(({ data }) => {
          if (data.code === 1) {
            this.placeOptions = data.data
          }
        })
        .catch()
    },
    loadAdminUserForW() {
      this.$axios
        .get('api/expmanage/getreceiver')
        .then(({ data }) => {
          if (data.code === 1) {
            this.adminUserOptions_w = data.data
          }
        })
        .catch()
    },
    loadAdminUser() {
      this.$axios
        .get('api/expmanage/getreceiver')
        .then(({ data }) => {
          if (data.code === 1) {
            this.adminUserOptions = data.data
          }
        })
        .catch()
    },
    changeTitle(val) {
      this.watchDetail_in_arr = []
      val.map(item => {
        this.titleIdOptions.map(i => {
          if (i.id === item) {
            this.watchDetail_in_arr.push(i.title + ':' + '\n')
          }
        })
      })
    },
    loadTitle(id, ifChange) {
      this.titleIdOptions = []
      this.serviceInForm.title = []
      this.serviceInForm.detail_in = ''
      if (ifChange) {
        this.editForm.title = []
        this.editForm.detail_in = ''
      }
      if (id) {
        this.$axios
          .get('api/servicein/gettitle?cate_id=' + id)
          .then(({ data }) => {
            if (data.code === 1) {
              this.titleIdOptions = data.data
            }
          })
          .catch()
      }
    },
    loadCategory() {
      this.$axios
        .get('api/schedule/getcate')
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryIdOptions = data.data
          }
        })
        .catch()
    },
    clearNot(val) {
      if (!val) {
        this.serviceInForm.doner_id_w = ''
        this.serviceInForm.address = ''
      }
    },
    getComUser(val) {
      if (val) {
        this.$axios
          .get('api/servicein/getcomuser?company_id=' + val)
          .then(res => {
            const { data } = res
            if (data.code === 1) {
              this.serviceInForm.customer_name = data.data[1]
              this.serviceInForm.customer_id = data.data[0]
            }
          })
      }
    },
    searchArrItemCompanys(query) {
      this.$axios.get('/api/admin/searchCompany_a?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.searchCompanies = data.data.companies
        }
      })
    },
    searchRemoteCompanyMethod(query) {
      if (query !== '') {
        this.searchLoading = true
        this.searchArrItemCompanys(query)
        setTimeout(() => {
          this.searchLoading = false
        }, 200)
      } else {
        this.searchCompanies = []
      }
    },
    handleClose_matter(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.$refs.serviceInForm.resetFields()
          this.orderData = null
          this.expData = null
          this.customerData = null
          this.fileList = []
          this.needUrl = []
          this.change = false
          done()
        })
        .catch(_ => { })
    },
    getLoginer() {
      this.$axios.get('api/expmanage/getloginer').then(res => {
        const { data } = res
        if (data.code === 1) {
          this.expruleForm.name = data.data
          this.getPersonPhone(data.data)
        }
      })
    },
    cancelOrder(val) {
      if (!val) {
        this.placeRadio = true
        this.expruleForm.name = ''
        this.expruleForm.sender_phone = ''
      } else {
        this.placeRadio = false
        this.getSender()
        this.getLoginer()
      }
    },
    getFrom() {
      this.$axios
        .get('api/admin/other_orders/get_froms')
        .then(({ data }) => {
          if (data.code === 1) {
            this.fromOptions = data.data
          }
        })
        .catch()
    },
    saveChange(formName) {
      if (!this.expruleForm.company_id) {
        this.$message.warning('请先选择公司！')
        return false
      }
      this.$refs[formName].validate(valid => {
        if (
          !this.addAddressForm.receiver_place_pro ||
          !this.addAddressForm.receiver_place_city ||
          !this.addAddressForm.receiver_place_town
        ) {
          this.$message.error('请选择完整收件人区域省市区！')
          return false
        }
        if (valid) {
          this.$axios
            .post(
              'api/expmanage/storeuseraddress?company_id=' +
              this.expruleForm.company_id,
              this.addAddressForm
            )
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                let myEvent = new Event('click')
                document.dispatchEvent(myEvent)
                this.addAddressForm.addressee = ''
                this.addAddressForm.address = ''
                this.addAddressForm.address_phone = ''
                this.addAddressForm.receiver_place_pro = ''
                this.addAddressForm.receiver_place_city = ''
                this.addAddressForm.receiver_place_town = ''
                this.$message.success(data.msg)
                this.getUserAddress(this.expruleForm.company_id)
              } else {
                this.$message.error(data.msg)
              }
            })
        } else {
          return false
        }
      })
    },
    resetSome() {
      this.cIndex = null
      this.expruleForm.receiver_s = ''
      this.expruleForm.receiver_phone = ''
    },
    doEdit(formName) {
      if (this.editAddressId) {
        this.$refs[formName].validate(valid => {
          if (
            !this.editAddressForm.receiver_place_pro ||
            !this.editAddressForm.receiver_place_city ||
            !this.editAddressForm.receiver_place_town
          ) {
            this.$message.error('请选择完整收件人区域省市区！')
            return false
          }
          if (valid) {
            this.editAddressForm.id = this.editAddressId
            this.$axios
              .put('api/expmanage/editaddress', this.editAddressForm)
              .then(res => {
                const { data } = res
                if (data.code === 1) {
                  this.$message.success(data.msg)
                  this.editAddressDialog = false
                  this.editAddressId = null
                  this.getUserAddress(this.secondLoadId)
                } else {
                  this.$message.error(data.msg)
                }
              })
          } else {
            return false
          }
        })
      }
    },
    getAddressTown(pid) {
      this.editAddressForm.receiver_place_town = ''
      this.$axios.get('api/expmanage/getaddresstown?pid=' + pid).then(res => {
        const { data } = res
        if (data.code === 1) {
          this.addressTownOptions = data.data
        }
      })
    },
    getAddressCity(pid) {
      this.editAddressForm.receiver_place_city = ''
      this.editAddressForm.receiver_place_town = ''
      this.$axios.get('api/expmanage/getaddresscity?pid=' + pid).then(res => {
        const { data } = res
        if (data.code === 1) {
          this.addressCityOptions = data.data
        }
      })
    },
    getAddressPro() {
      this.$axios.get('api/expmanage/getaddresspro').then(res => {
        const { data } = res
        if (data.code === 1) {
          this.addressProOptions = data.data
        }
      })
    },
    openEditAddressDialog(item) {
      this.getAddressPro()
      this.getAddressCity(item.receiver_place_pro)
      this.getAddressTown(item.receiver_place_city)
      this.editAddressId = item.id
      this.editAddressForm.addressee = item.addressee
      this.editAddressForm.address_phone = item.address_phone
      this.editAddressForm.receiver_place_pro = item.receiver_place_pro
      this.editAddressForm.receiver_place_city = item.receiver_place_city
      this.editAddressForm.receiver_place_town = item.receiver_place_town
      this.editAddressForm.address = item.address
      this.editAddressDialog = true
    },
    chooseThis(item, index) {
      this.cIndex = index
      this.sIndex = index
      this.expruleForm.receiver_s = item.addressee
      this.expruleForm.receiver_phone = item.address_phone
      this.expruleForm.receiver_place_pro = item.pro ? item.pro.name : ''
      this.expruleForm.receiver_place_city = item.city ? item.city.name : ''
      this.expruleForm.receiver_place_town = item.town ? item.town.name : ''
      this.expruleForm.receiver_address = item.address
      this.expruleForm.exp_phone = item.address_phone
    },
    createOrder_e(money, companyId, remark) {
      this.$axios
        .post('api/expmanage/createOrder', { money, companyId, remark })
        .then(({ data }) => {
          if (data.code === 1) {
            this.expruleForm.wxOrder = data.data
            this.submitForm_e('expruleForm')
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    submitForm_e(formName) {
      this.$refs[formName].validate(valid => {
        if (this.expruleForm.exp_phone !== '') {
          let reg = /^1[3456789]\d{9}$/
          if (!reg.test(this.expruleForm.exp_phone)) {
            this.$message.error('请输⼊有效的⼿机号码')
            return false
          }
        }
        if (this.expruleForm.receiver_phone !== '') {
          let re = /^1[3456789]\d{9}$/
          if (!re.test(this.expruleForm.receiver_phone)) {
            this.$message.error('请输⼊有效的⼿机号码')
            return false
          }
        }
        if (valid) {
          this.$axios
            .post('/api/expmanage/expmanagein', {
              company_name: this.expruleForm.company_id.split('|')[1],
              company_id: this.expruleForm.company_id.split('|')[0],
              exp_company: this.expruleForm.exp_company,
              exp_num: this.expruleForm.exp_num,
              exp_phone: this.expruleForm.exp_phone,
              exp_content: this.expruleForm.exp_content,
              exp_status: this.expruleForm.exp_status,
              receiver: this.expruleForm.receiver,
              receiver_s: this.expruleForm.receiver_s,
              sor: this.expruleForm.sor,
              receiver_phone: this.expruleForm.receiver_phone,
              buy: this.expruleForm.buy,
              pay: this.expruleForm.pay,
              remark: this.expruleForm.remark,
              is_buy: this.expruleForm.is_buy,
              order_code: this.expruleForm.order_code,
              name: this.expruleForm.name,
              sender_phone: this.expruleForm.sender_phone,
              place: this.expruleForm.place,
              receiver_place_pro: this.expruleForm.receiver_place_pro,
              receiver_place_city: this.expruleForm.receiver_place_city,
              receiver_place_town: this.expruleForm.receiver_place_town,
              receiver_address: this.expruleForm.receiver_address,
              wx_order: this.expruleForm.wxOrder
            })
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.expManageIndrawer = false
                this.userAdressOptions = []
                this.cIndex = null
                this.typein = false
                this.resetForm('expruleForm')
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    createOrder(money, companyId, remark) {
      this.$axios
        .post('api/expmanage/createOrder', { money, companyId, remark })
        .then(({ data }) => {
          if (data.code === 1) {
            this.expruleForm.wxOrder = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    getOrder() {
      if (!this.expruleForm.name) {
        this.$message.error('请填写发件人！')
        return false
      }
      if (!this.expruleForm.sender_phone) {
        this.$message.error('请填写发件人手机号！')
        return false
      }
      let reg = /^1[3456789]\d{9}$/
      if (!reg.test(this.expruleForm.sender_phone)) {
        this.$message.error('请填写正确的发件人手机号！')
        return false
      }
      if (
        !this.expruleForm.receiver_s ||
        !this.expruleForm.receiver_phone ||
        !this.expruleForm.receiver_address
      ) {
        this.$message.error('请先选择地址！')
        return false
      }
      if (
        !this.expruleForm.receiver_place_pro ||
        !this.expruleForm.receiver_place_city ||
        !this.expruleForm.receiver_place_town
      ) {
        this.$message.error('请选择完整收件人区域省市区！')
        return false
      }
      if (this.expruleForm.exp_content.length <= 0) {
        this.$message.error('请选择快递内容！')
        return false
      }
      if (!this.expruleForm.quantity) {
        this.$message.error('请填写包裹数量！')
        return false
      }
      if (this.expruleForm.quantity > 30) {
        this.$message.error('包裹数量不能超过30！')
        return false
      }
      if (!this.expruleForm.place) {
        this.$message.error('请选择发货地址！')
        return false
      }
      let expCompany = this.expruleForm.exp_company
      let place = this.expruleForm.place
      let receiver = this.expruleForm.receiver_s
      let receiverPhone = this.expruleForm.receiver_phone
      let receiverAddress = this.expruleForm.receiver_address
      let name = this.expruleForm.name
      let senderPhone = this.expruleForm.sender_phone
      let receiverPlacePro = this.expruleForm.receiver_place_pro
      let receiverPlaceCity = this.expruleForm.receiver_place_city
      let receiverPlaceTown = this.expruleForm.receiver_place_town
      let expContent = this.expruleForm.exp_content
      let quantity = this.expruleForm.quantity
      let remark = this.expruleForm.remark
      let PayType = this.expruleForm.PayType
      let buy = this.expruleForm.buy
      this.$axios
        .get('api/expmanage/getorder', {
          params: {
            expCompany,
            place,
            receiver,
            receiverPhone,
            receiverAddress,
            name,
            senderPhone,
            receiverPlacePro,
            receiverPlaceCity,
            receiverPlaceTown,
            expContent,
            quantity,
            remark,
            PayType,
            buy
          }
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.expruleForm.exp_num = data.data.LogisticCode
            this.expruleForm.order_code = data.data.OrderCode
            // 生成小程序支付订单
            if (
              this.expruleForm.buy === 'c' &&
              this.expruleForm.pay > 0 &&
              this.expruleForm.is_buy === '0'
            ) {
              this.createOrder(
                this.expruleForm.pay,
                this.expruleForm.company_id,
                this.expruleForm.remark
              )
            }
            this.submitForm_e('expruleForm')
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (this.expruleForm.exp_phone !== '') {
          let reg = /^1[3456789]\d{9}$/
          if (!reg.test(this.expruleForm.exp_phone)) {
            this.$message.error('请输⼊有效的⼿机号码')
            return false
          }
        }
        if (this.expruleForm.receiver_phone !== '') {
          let re = /^1[3456789]\d{9}$/
          if (!re.test(this.expruleForm.receiver_phone)) {
            this.$message.error('请输⼊有效的⼿机号码')
            return false
          }
        }
        if (valid) {
          if (this.expruleForm.is_now) {
            this.getOrder()
          } else {
            if (
              this.expruleForm.buy === 'c' &&
              this.expruleForm.pay > 0 &&
              this.expruleForm.is_buy === '0'
            ) {
              this.createOrder_e(
                this.expruleForm.pay,
                this.expruleForm.company_id,
                this.expruleForm.remark
              )
            } else {
              this.$axios
                .post('/api/expmanage/expmanagein', {
                  company_name: this.expruleForm.company_id.split('|')[1],
                  company_id: this.expruleForm.company_id.split('|')[0],
                  exp_company: this.expruleForm.exp_company,
                  exp_num: this.expruleForm.exp_num,
                  exp_phone: this.expruleForm.exp_phone,
                  exp_content: this.expruleForm.exp_content,
                  exp_status: this.expruleForm.exp_status,
                  receiver: this.expruleForm.receiver,
                  receiver_s: this.expruleForm.receiver_s,
                  sor: this.expruleForm.sor,
                  receiver_phone: this.expruleForm.receiver_phone,
                  buy: this.expruleForm.buy,
                  pay: this.expruleForm.pay,
                  remark: this.expruleForm.remark,
                  is_buy: this.expruleForm.is_buy
                })
                .then(res => {
                  const { data } = res
                  if (data.code === 1) {
                    this.$message.success(data.msg)
                    this.expManageIndrawer = false
                    this.userAdressOptions = []
                    this.cIndex = null
                    this.typein = false
                    this.resetForm('expruleForm')
                  }
                })
                .catch()
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    signLoadExpContent() {
      this.expContentOptions = []
      this.$axios.get('api/expmanage/getcate').then(res => {
        const { data } = res
        if (data.code === 1) {
          this.signExpContentOptions = data.data
        }
      })
    },
    searchInput(query) {
      if (query !== '') {
        this.searchLoading = true
        this.searchInputItem(query)
        setTimeout(() => {
          this.searchLoading = false
        }, 200)
      } else {
        this.userOptions = []
      }
    },
    clearChildren(val) {
      if (val === 'w') {
        this.searchArr.pay = ''
      }
    },
    getSender() {
      this.$axios.get('api/expmanage/getreceiver').then(res => {
        const { data } = res
        if (data.code === 1) {
          this.senderOptions = data.data
        }
      })
    },
    getPersonPhone(val) {
      this.$axios
        .get('api/expmanage/getpersonphone?userId=' + val, {})
        .then(res => {
          this.placeRadio = false
          const { data } = res
          if (data.code === 1) {
            this.expruleForm.sender_phone = data.data
          }
        })
    },
    getUserAddress(id) {
      this.secondLoadId = id
      this.userAdressOptions = []
      this.expruleForm.receiver_s = ''
      this.expruleForm.exp_phone = ''
      this.expruleForm.receiver_phone = ''
      this.cIndex = null
      if (id) {
        this.$axios.get('api/expmanage/getuseraddress?id=' + id).then(res => {
          const { data } = res
          if (data.code === 1) {
            this.userAdressOptions = data.data
          }
        })
      }
    },
    searchArrItemCompanysTypein(query) {
      this.$axios.get('/api/admin/searchCompany_a?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.searchCompaniesTypein = data.data.companies
        }
      })
    },
    searchRemoteCompanyMethodTypein(query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchArrItemCompanysTypein(query)
        }, 200)
      } else {
        this.searchCompaniesTypein = []
      }
    },
    getUserPhone(id) {
      if (id) {
        this.$axios.get('api/expmanage/getuserphone?id=' + id).then(res => {
          const { data } = res
          if (data.code === 1) {
            this.expruleForm.exp_phone = data.data
          }
        })
      }
    },
    getReceiver() {
      this.$axios.get('/api/expmanage/getreceiver').then(res => {
        const { data } = res
        if (data.code === 1) {
          data.data.unshift({ id: null, username: '未知' })
          this.receiverOptions = data.data
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.resetForm('expruleForm')
          this.addAddressForm.addressee = ''
          this.addAddressForm.address = ''
          this.addAddressForm.address_phone = ''
          this.userAdressOptions = []
          this.cIndex = null
          this.typein = false
          this.placeRadio = false
          done()
        })
        .catch(_ => { })
    },
    handleExpOpen() {
      this.expContentOptions = []
      this.expManageIndrawer = true
      this.$axios.get('api/expmanage/getcate').then(res => {
        const { data } = res
        if (data.code === 1) {
          this.expContentOptions = data.data
        }
      })
    },
    handleGetCounts() {
      this.$axios
        .get('/api/admin/tyc_order/counts?page=' + 1 + '', {
          loadingClose: true
        })
        .then(res => {
          let { data } = res
          if (data.code === 0) {
            this.personnel = data.data.personnel
            this.features = data.data.features
            this.orderRegs = data.data.orderRegs
            this.regTypes = data.data.regTypes
            this.citys = data.data.cities
            this.meals = data.data.meals
            this.mealSingles = data.data.mealSingles
            this.causes = data.data.causes
            this.sources = data.data.sources
          }
        })
    },
    loadMoneyInCate() {
      this.$axios
        .get('api/moneyin/getcate')
        .then(({ data }) => {
          if (data.code === 1) {
            this.moneyInCateOptions = data.data
          }
        })
        .catch()
    },
    remoteMethod_o(query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.searchCompanys_o(query)
        }, 200)
      } else {
        this.companies_o = []
      }
    },
    searchCompanys_o(query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.companies_o = data.data.companies
        }
      })
    },
    handBindingSave() {
      if (!this.psId) {
        this.$message.error('请输入小程序用户编号')
        return
      }
      this.$axios.get('/api/customer/bindingreferees?id=' + this.psId, this.addData).then(res => {
        const { data } = res
        if (data.code === 1) {
          this.$message.success(data.msg)
          this.Binding = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    handleAddSave() {
      if (!this.addData.company_id) {
        this.$message.error('公司不能为空')
        return
      }
      if (!this.addData.bussin_content) {
        this.$message.error('商机内容不能为空')
        return
      }
      if (!this.addData.urgency) {
        this.$message.error('商机紧急程度不能为空')
        return
      }
      this.$axios.post('/api/bussin_change', this.addData).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.$message.success(data.msg)
          this.BODialog = false
          this.clearAdd()
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    getBussinChangeData() {
      this.$axios
        .get('/api/bussin_change?page=' + this.pageOption.currentPage + '')
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.bussiness_change = data.data.list.data
            this.users = data.data.users
            this.contents = data.data.contents
            this.user_id = data.data.user_id
            this.bussiness_content = data.data.bussiness_content
            this.pageOption.total = data.data.list.total
            this.pageOption.currentPage = data.data.list.current_page
          }
        })
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.searchCompanys(query)
        }, 200)
      } else {
        this.companies = []
      }
    },
    searchCompanys(query) {
      this.$axios.get('/api/admin/searchCompany_a?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.companies = data.data.companies
        }
      })
    },
    clearAdd() {
      this.addData.uid = ''
      this.addData.urgency = 1
      this.addData.company_id = ''
      this.addData.bussin_content = []
      this.addData.remark = ''
    },
    handleBODialogClose(done) {
      this.clearAdd()
      done()
    },
    handleBindingClose(done) {
      done()
    },
    handleBOOpen() {
      this.getBussinChangeData()
      this.BODialog = true
    },
    handBinding() {
      this.Binding = true
    },
    mouseOver(n) {
      this.mover = n
    },
    mouseLeave() {
      this.mover = false
    },
    sendMsgFormSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .get('api/head/send_msg', {
              params: this.sendMsgForm
            })
            .then(res => {
              let { data } = res
              if (data.code === 1) {
                this.$refs[formName].resetFields()
                this.sendMsgDialog = false
                this.$message.success(data.msg)
              } else {
                this.$message.error(data.msg)
              }
            })
        }
      })
    },
    sendEncryptPhoneFormSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .get('api/phone_encrypt_phone', {
              params: {
                phone: this.encryptPhoneForm.phone
              }
            })
            .then(res => {
              let { data } = res
              if (data.code === 200) {
                this.encryptPhoneForm.encryptedPhone = data.data
                this.$message.success(data.msg)
                this.$nextTick(_ => {
                  setTimeout(_ => {
                    this.ysyCopySome(this.encryptPhoneForm.encryptedPhone)
                  }, 300)
                })
              } else {
                this.$message.error(data.msg)
              }
            })
        }
      })
    },
    sendDecryptPhoneFormSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .get('api/phone_decrypt_phone', {
              params: {
                phone_encrypt: this.decryptPhoneForm.encryptedPhone
              }
            })
            .then(res => {
              let { data } = res
              if (data.code === 200) {
                this.decryptPhoneForm.phone = data.data
                this.$message.success(data.msg)
                this.$nextTick(_ => {
                  setTimeout(_ => {
                    this.ysyCopySome(this.decryptPhoneForm.phone)
                  }, 300)
                })
              } else {
                this.$message.error(data.msg)
              }
            })
        }
      })
    },
    handleSendMsgDialogClose(done) {
      this.$refs.sendMsgForm.resetFields()
      done()
    },
    handleEncryptPhoneDialogClose(done) {
      this.$refs.encryptPhoneForm.resetFields()
      this.encryptPhoneForm.encryptedPhone = ''
      done()
    },
    handleExportPhoneDialogClose(done) {
      done()
    },
    handleDecryptPhoneDialogClose(done) {
      this.$refs.decryptPhoneForm.resetFields()
      this.decryptPhoneForm.phone = ''
      done()
    },
    openSendMsgDialog() {
      this.sendMsgDialog = true
    },
    openEncryptPhoneDialog() {
      this.encryptPhoneDialog = true
    },
    openExportPhoneDialog() {
      this.exportPhoneDialog = true
    },
    openDecryptPhoneDialog() {
      this.decryptPhoneDialog = true
    },
    handleCommand(command) {
      switch (command) {
        case 'info':
          this.showInfo()
          break
        case 'logout':
          this.logout()
          break
      }
    },
    showInfo() {
      if (this.$route.path === '/admin_user') return
      this.$router.push('/admin_user')
      // this.$store.dispatch('openHeadForm', true)
    },
    logout() {
      localStorage.removeItem('token')
      location.href = '/login'
    },
    callEvent() {
      let regPhone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/

      if (!regPhone.test(this.callPhone)) {
        this.$message.error('手机号格式错误')
        return
      }

      this.$axios.post('/api/admin/call_logs/' + this.callPhone).then(res => {
        let { data } = res
        if (data.code === 0) {
          this.$message.success('调用成功，请注意接听来电')
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    handleComOpen() {
      this.addComdVisible = true
    },
    handleAddComClose(done) {
      this.$refs['addComform'].resetFields()
      done()
    },
    onAddSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('/api/admin/companies', this.addComForm)
            .then(res => {
              let { data } = res
              if (data.code === 0) {
                this.$refs[formName].resetFields()
                this.addComdVisible = false
                this.$message.success(data.msg)
              } else {
                this.$message.error(data.msg)
              }
            })
        }
      })
    },
    whetherOnlineFun(status, uid) {
      this.$axios.get('/api/admin/users/whetheronlinefun?status=' + status + '&uid=' + uid)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.userinfo.whether_online = data.data.status
          }
        })
    },
    handleShowChat() {
      this.$emit('showChat', 'chat')
    },
    async getExecuteUrl() {
      const host = await loadAutoHyperHost()
      return `${host}qyh/phone_location/export`;
    },
    exportTaskAnswer(data) {
      if (data.code == 0) {
        this.$message.success(data.msg)
      } else {
        this.$message.error(data.msg)
      }
    },
    handleImportStart1(params) {
      if (!params || !params.taskId) {
        return
      }

      this.destroyNotify();

      const { taskId } = params

      this.importNotifyInstance = this.$importNotify.start({
        taskId: taskId,
        wsUrl: `${socketIOAddress}`,
        onProgress: (progressData) => {

        },
        onError: (errMsg) => {
          this.$message.error(`导入进度通知错误：${errMsg}`)
          this.destroyNotify();
        }
      })

      this.$message.info(`发票导入任务已启动（ID：${taskId}），右上角显示进度，可切换到任意界面，进度依旧保持`);
    },
    destroyNotify() {
      if (this.importNotifyInstance) {
        this.importNotifyInstance.$destroy();
        this.importNotifyInstance = null;
        console.log('已关闭导入进度通知');
      }
    },
    handleImportStart(data) {
      if (this.socket) {
        this.socket.emit('join-room', data.taskId)
        this.$importNotify.show({
          taskId: data.taskId,
          fileName: data.fileName || 'Excel文件',
          autoClose: data.autoClose || false // 明确指定是否自动关闭
        });
        return;
      }
      this.socket = io(`${socketIOAddress}`, { transports: ['websocket'] })
      this.socket.on('connect', () => {
        this.socket.emit('join-room', data.taskId)
        this.$importNotify.show({
          taskId: data.taskId,
          fileName: data.fileName || 'Excel文件',
          autoClose: data.autoClose || false
        })
      })
      this.socket.on('import-progress', (data) => {
        this.handlePushData(data)
      })
    },
    handlePushData(data) {
      try {
        // 解析数据（支持字符串/对象）
        const progressData = typeof data === 'string' ? JSON.parse(data) : data;
        // 一行代码更新通知
        this.$importNotify.update(progressData);
      } catch (e) {
        console.error('推送处理失败:', e);
      }
    }
  },
  mounted() {
    this.$bus.$on('invoice:import:start', (data) => {
      this.handleImportStart(data);
    })
  },
  beforeDestroy() {
    this.$bus.$off('invoice:import:start', this.handleImportStart);
    if (this.socket) {
      this.socket.disconnect()
      this.socket = null
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

.el-select {
  width: 100%;
}

.el-form >>> .text-r {
  text-align: right;
}

.head-nav {
  position: fixed;
  width: 100%;
  min-width: 12rem;
  height: $headerHeight;
  padding: 0.1rem;
  background: $bgColor;
  color: $homeTextColor;
  border-bottom: 1px solid $bgColor;
  z-index: 99;

  .call-coll {
    line-height: $headerHeight;
    float: right;
  }

  .call-event {
    cursor: pointer;
  }

  .logo-container {
    min-width: 3.2rem;
    line-height: $headerHeight;
    padding-left: 0.3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo {
      width: 1rem;
      height: 1rem;
      margin-right: 0.1rem;
      vertical();
    }

    .title {
      vertical-align: middle;
      font-size: 0.44rem;
      letter-spacing: 0.06rem;
    }
  }

  .com-add-btn {
    font-size: 0.4rem;
    margin-right: 0.2rem;
    cursor: pointer;
  }

  .user {
    line-height: 1.1rem;
    text-align: right;
    float: right;
    padding-right: 0.2rem;

    .el-avatar--circle {
      vertical-align: middle;
    }

    .userinfo {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .username {
      cursor: pointer;
      margin-right: 0.1rem;
      font-size: 28px;

      .el-dropdown {
        color: #fff;
      }
    }

    .avatar {
      width: 0.8rem;
      height: 0.8rem;
      border-radius: 50%;
      vertical();
      vertical();
    }
  }

  .call-input {
    text-align: right;
    line-height: $headerHeight;
    float: right;
  }
}
</style>
<style scoped>
.pmt {
  margin-top: -0.03rem;
  white-space: nowrap;
}

.mon {
  background-color: #e9e9eb;
}

.m-label {
  line-height: 0.64rem;
}

.mt-10 {
  margin-top: 0.2rem;
}

.rmt {
  margin-top: 0.2rem;
}

.rmb {
  margin-bottom: 0.2rem !important;
}

.tr {
  text-align: right;
}

.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;
}

.el-drawer__wrapper>>>.el-drawer {
  overflow-y: auto;
}

.bottom-btn {
  padding: 0.2rem;
  text-align: right;
}

.active {
  border: 1.2px solid #000000 !important;
}

.drawer-content {
  padding: 0 0.4rem 0 0.4rem;
}

.mb-10 {
  margin-bottom: 0.2rem;
}

.num-cell {
  padding: 0.2rem 0;
  text-align: center;
}

.num {
  width: 0.8rem;
  height: 0.8rem;
  text-align: center;
  line-height: 0.8rem;
  border-radius: 50%;
  background-color: #f3f4f6;
  box-shadow: 0px 1px 5px #888888;
  display: inline-block;
  cursor: pointer;
  user-select: none;
}

.tabs_line {
  display: flex;
}

.lines {
  width: .06rem;
  height: .30rem;
  background: #4C87FC;
  margin-right: .1rem;
}

.tabs-title {
  color: #000000;
  font-weight: bold;
}

.text_right {
  text-align: left;
}

.divider_style {
  margin-top: .05rem;
  margin-bottom: .03rem;
  padding: 0 .05rem;
}

.span_whether {
  width: 100%;
}

.tr-margin {
  margin-bottom: .2rem;
}
</style>



// WEBPACK FOOTER //
// src/common/HeadNav.vue